import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, createTextVNode as _createTextVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7320d585"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "text-left flex flex-col text-textPrimary relative w-full"
}
const _hoisted_2 = { class: "flex items-center gap-2 md:gap-3 mb-1 flex-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-lg md:text-2xl text-textPrimary" }, "Detalhes do Plantão", -1))
const _hoisted_4 = { class: "text-xs md:text-base truncate" }
const _hoisted_5 = {
  key: 2,
  class: "hidden md:flex absolute right-[2.5vw] top-[11vh] z-20 flex-col items-end gap-3"
}
const _hoisted_6 = {
  key: 0,
  class: "relative inline-flex"
}
const _hoisted_7 = ["disabled", "title", "aria-label"]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = {
  key: 4,
  class: "relative flex flex-col items-center"
}
const _hoisted_10 = {
  key: 0,
  class: "absolute top-full mt-3 flex flex-col items-center gap-3 z-10"
}
const _hoisted_11 = {
  key: 0,
  class: "relative inline-flex"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 1,
  class: "relative inline-flex"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 3,
  class: "flex md:hidden flex-row items-center gap-2 mt-2"
}
const _hoisted_16 = {
  key: 0,
  class: "relative inline-flex"
}
const _hoisted_17 = ["disabled", "title", "aria-label"]
const _hoisted_18 = ["disabled", "title"]
const _hoisted_19 = {
  key: 4,
  class: "relative inline-flex"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 5,
  class: "relative inline-flex"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 4,
  class: "hidden md:flex absolute right-[2.5vw] top-[11vh] z-20 flex-col items-end gap-3"
}
const _hoisted_24 = {
  key: 0,
  class: "relative inline-flex"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled", "title"]
const _hoisted_27 = {
  key: 5,
  class: "flex md:hidden flex-row items-center gap-2 mt-2"
}
const _hoisted_28 = {
  key: 0,
  class: "relative inline-flex"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled", "title"]
const _hoisted_31 = {
  class: "flex flex-wrap gap-1.5",
  "data-testid": "station-details-mobile-badges"
}
const _hoisted_32 = ["data-testid"]
const _hoisted_33 = {
  key: 1,
  class: "text-center text-red-500 py-4"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "flex flex-col gap-4 pb-4" }
const _hoisted_36 = {
  key: 0,
  id: "allocated-by-info",
  class: "flex gap-2"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-gray-500" }, "Escalado por:", -1))
const _hoisted_38 = {
  key: 0,
  class: "bg-gray-200 rounded px-2"
}
const _hoisted_39 = {
  id: "shift-period-timezone",
  class: "text-left flex flex-col"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "font-bold" }
const _hoisted_42 = { class: "font-bold" }
const _hoisted_43 = {
  key: 1,
  class: "text-left"
}
const _hoisted_44 = { class: "font-bold" }
const _hoisted_45 = { class: "font-bold" }
const _hoisted_46 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_47 = { class: "flex mb-3" }
const _hoisted_48 = {
  key: 0,
  class: "text-left gap-4 flex flex-col"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Valores do plantão", -1))
const _hoisted_50 = { class: "flex flex-row flex-wrap gap-2 mb-3" }
const _hoisted_51 = {
  key: 1,
  class: "grid grid-cols-2 md:grid-cols-4 gap-3 text-left"
}
const _hoisted_52 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Time", -1))
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "flex flex-col" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Posição", -1))
const _hoisted_57 = { class: "flex flex-col" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Turno", -1))
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Regra de proporcionalidade", -1))
const _hoisted_61 = {
  key: 3,
  id: "duty-details-section",
  class: "flex flex-col gap-4"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = {
  key: 1,
  class: "flex flex-col md:flex-row gap-4",
  "data-testid": "station-payment-rules-cards"
}
const _hoisted_64 = {
  key: 0,
  class: "flex flex-1 flex-col gap-1 rounded-lg border border-lightGray30 px-3 py-3 text-left text-sm md:px-4",
  "data-testid": "station-repass-mode-card"
}
const _hoisted_65 = { class: "font-bold text-left" }
const _hoisted_66 = {
  key: 0,
  class: "text-left"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-left italic text-gray-400" }, "Não definida", -1))
const _hoisted_68 = {
  key: 0,
  class: "flex items-center gap-1 text-xs text-left",
  style: {"color":"#8a5a05"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "16",
    x2: "12.01",
    y2: "16"
  })
], -1))
const _hoisted_70 = {
  key: 1,
  class: "flex flex-1 flex-col gap-1 rounded-lg border border-lightGray30 px-3 py-3 text-left text-sm md:px-4",
  "data-testid": "station-proportionality-rule-card"
}
const _hoisted_71 = { class: "font-bold text-left" }
const _hoisted_72 = {
  key: 0,
  class: "text-left"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-left italic text-gray-400" }, "Não definida", -1))
const _hoisted_74 = {
  key: 0,
  class: "flex items-center gap-1 text-xs text-left",
  style: {"color":"#8a5a05"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "16",
    x2: "12.01",
    y2: "16"
  })
], -1))
const _hoisted_76 = { class: "flex flex-wrap items-start gap-4 text-left" }
const _hoisted_77 = { class: "flex min-w-[190px] flex-col gap-2" }
const _hoisted_78 = { class: "text-sm font-bold" }
const _hoisted_79 = {
  key: 1,
  class: "text-sm text-gray-500",
  "data-testid": "verification-none"
}
const _hoisted_80 = { class: "flex min-w-[140px] flex-col gap-2" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold" }, "Anexos do check", -1))
const _hoisted_82 = {
  key: 2,
  class: "text-sm text-gray-500"
}
const _hoisted_83 = { class: "rounded-lg border-[2px] border-primary p-2" }
const _hoisted_84 = {
  key: 9,
  "data-testid": "attendance-status-error",
  class: "text-negative text-sm text-left my-2"
}
const _hoisted_85 = { class: "flex flex-wrap items-center gap-3 text-left text-sm" }
const _hoisted_86 = { "data-testid": "station-details-exceptionality-summary" }
const _hoisted_87 = { class: "rounded-lg border-[2px] border-primary p-2" }

import { ref, watch, computed, nextTick, defineAsyncComponent } from 'vue'
import { useToast } from 'vue-toastification'
import { getApiErrorMessage } from '@/utils/apiError'
import { useErrorToast } from '@/composables/useErrorToast'
import PadlockButton from '@/components/designSystem/Buttons/PadlockButton/Index.vue'
import NetworkService from '@/Network/index'
import CardDutyFee from '@/components/designSystem/Cards/CardDutyFee.vue'
import CardDutyWithDoctor from '@/components/designSystem/Cards/CardDutyWithDoctor.vue'
import StationDetailsSkeleton from '@/components/designSystem/Skeleton/StationDetailsSkeleton.vue'
import StationDetailsHeaderSkeleton from '@/components/designSystem/Skeleton/StationDetailsHeaderSkeleton.vue'
import EditPencilIcon from '@/assets/icons/pencil.vue'
import AccountSwitchIcon from '@/assets/icons/account-switch.vue'
import { timezones } from '@/hooks/useCommon'
import ObservationList from '@/components/ObservationList.vue'
import ExceptionalitiesSidebar from '../sidebars/ExceptionalitiesSidebar.vue'

import NewExceptionalityRequest from '../sidebars/NewExceptionalityRequest.vue'
import { differenceInHours } from 'date-fns'
import { DoctorStationObservationListResponse } from '@/Network/Types/Responses/DsObservationResponse'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { CheckEvidence } from '@/Network/Types/Requests/StationRequests'
import { ShiftDetails } from '@/Network/Types/Responses/StationResponses'
import { hasInstantPassed } from '@/utils/date'
import { getProportionalityRuleTitle } from '@/utils/schedule'
import { getVerificationButtonState } from '@/utils/check-verification'
import {
  VERIFICATION_BUTTON_LABELS,
  VERIFICATION_COLUMN_HEADER
} from '@/constants/check-verification.constants'
import { getCheckOriginLabel } from '@/utils/doctorStation'
import { mapAuditTrailToHistoryEvents } from '@/utils/dsAttendanceHistory'

import CheckAttemptsButton from '@/components/designSystem/Buttons/CheckAttemptsButton/index.vue'
import CheckAttemptsPanel from '@/components/CheckAttempts/CheckAttemptsPanel.vue'
import CollapsibleSection from './CollapsibleSection.vue'
import DashboardModalShell from '../mobile/DashboardModalShell.vue'
import MobileOverlayLayer from '../mobile/MobileOverlayLayer.vue'
import StationDetailsDock from '../mobile/StationDetailsDock.vue'
import {
  useStationDetailActions,
  type StationDetailActionsVariant
} from '../composables/useStationDetailActions'
import { resolveStationLegLock } from '../composables/useStationLegLock'
import ValueDetailsSection from './ValueDetailsSection.vue'
import RepassProportionalityDetailsSection from './RepassProportionalityDetailsSection.vue'
import WorkJourneyDetailsSection from './WorkJourneyDetailsSection.vue'
import PostStationDetailsSection from './PostStationDetailsSection.vue'
import StationRegistrationSection from './StationRegistrationSection.vue'
import type { StationRegistrationView } from './StationRegistrationSection.vue'
import StationRequiredCheckLine from './StationRequiredCheckLine.vue'
import { useRouter } from 'vue-router'
import StationActivityRecordsSection from './StationActivityRecordsSection.vue'
import StationRecordsSection from './StationRecordsSection.vue'
import { useCanReadAttendance } from '@/modules/company/Approvals/DsAttendance/composables/useCanReadAttendance'
import type {
  RedirectToSheetPayload,
  SendRecordContext
} from '@/components/designSystem/modals/SendRecordModal/types'
import { buildSheetHandoff } from '@/components/designSystem/modals/SendRecordModal/types'
import type { DsAttendanceUploadForm } from '@/components/designSystem/modals/AttendanceUploadModal/types'

import {
  ExceptionStatusEnum,
  ExceptionSummary
} from '@/Network/Types/Requests/DoctorStationExceptionRequests'
import ExceptionService from '@/Network/Services/DoctorStationException'
import { ProportionalityRuleEnum } from '@/Network/Types/Requests/ScheduleRequests'
import HistorySidebar from '@/components/Sidebars/HistorySidebar.vue'
import AccountRemove from '@/assets/icons/account-remove.vue'
import DotsHorizontal from '@/assets/icons/dots-horizontal.vue'
import AccountPlus from '@/assets/icons/account-plus.vue'
import ManagementDoctorModal from '../modals/managementDoctor/management.doctor.modal.vue'
import RemoveDoctorModal from '../modals/removeDoctor/remove.doctor.modal.vue'
import UnidentifiedCoverageDetails from './UnidentifiedCoverageDetails.vue'
import OptionalCollapsible from './OptionalCollapsible.vue'
import { STATUS_CONFIG, UNKNOWN_STATUS_CONFIG } from '@/modules/company/PostStation/constants'
import { PostStationStatus } from '@/modules/company/PostStation/types'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import { CoverageStatus } from '@/Network/Types/Responses/CoverageResponses'
import { canMarkUnidentified, getStationCoverageInfo } from '@/utils/coverage'
import { addHours, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import EvidenceModal from './EvidenceModal.vue'
import CheckVerificationModal from './CheckVerificationModal.vue'
import StationEvidenceModal from './StationEvidenceModal.vue'
import type { StationEvidenceContext } from '@/types/station-evidence.types'
import { DSAttendanceStatus, DSAttendanceAuditType } from '@/constants/ds-attendance.constants'
import { HistoryEvent } from '@/components/designSystem/Cards/DsAttendanceHistoryCard.vue'
import AlertIcon from '@/assets/icons/mdiAlertCircle.vue'
import SVGIcon from '@/components/SVGIcon.vue'
import { mdiLockOpenVariant, mdiUpload } from '@mdi/js'
import { useDsAttendanceStore } from '@/pinia-store/useDsAttendanceStore'
import { CoveredLegs } from '@/constants/ds-attendance.constants'
import AttendanceAlert from '@/components/designSystem/Alerts/AttendanceAlert.vue'
import HistoryButton from '@/components/designSystem/Buttons/ViewChangeHistoryButton/index.vue'
import StationIdBadge from '@/components/designSystem/Badges/StationIdBadge.vue'
import { getPermanenceVisibility, shouldRefetchOnStationIdChange } from '@/utils/permanence'
import {
  usePostStationLock,
  type UsePostStationLock
} from '@/modules/company/PostStation/composables/usePostStationLock'

/**
 * M2 — o modal de envio é PESADO (5 passos, dropzone e visualizador) e serve uma
 * minoria dos plantões. Assíncrono + `v-if`: quem nunca clica em "Enviar
 * registro" não baixa nem executa a árvore da W4, e os specs que já montam este
 * modal continuam sem conhecê-la.
 */
export type StationDetailsContext = 'dashboard' | 'approvals'

export type ApprovalStatus = 'Approved' | 'Rejected' | null
export interface ApprovalStatusMap {
  financials: ApprovalStatus
  repassMode: ApprovalStatus
  proportionalityRule: ApprovalStatus
  workJourney: ApprovalStatus
}

type SpeedDialAction = 'send-record' | 'edit' | 'remove' | 'history'

interface FormattedDateTime {
  weekday: string
  date: string
  time: string
}

interface MobileBadge {
  id: 'type' | 'sector' | 'specialty' | 'external'
  label: string
  class: string
}

/** Selos do cabeçalho em tela cheia. "Externo" só quando há médico e ele é de fora. */

export default /*#__PURE__*/_defineComponent({
  __name: 'stationDetailsModal',
  props: {
    showModal: { type: Boolean },
    infos: {},
    mode: { default: 'dashboard' },
    isPushedExternally: { type: Boolean, default: false },
    exceptionIdSelected: {},
    approvalStatusMap: { default: () => ({
      financials: null,
      repassMode: null,
      proportionalityRule: null,
      workJourney: null
    }) },
    mobileShell: { type: Boolean, default: false },
    postStationLock: {}
  },
  emits: ['closeModal', 'editStation', 'navigateToStation', 'sendRecord'],
  setup(__props: any, { emit }) {

const props = __props;

const SendRecordModal = defineAsyncComponent(
  () => import('@/components/designSystem/modals/SendRecordModal/Index.vue')
)
const AttendanceUploadModal = defineAsyncComponent(
  () => import('@/components/designSystem/modals/AttendanceUploadModal/Index.vue')
)

const { flags } = useFeatureFlags()
const isEnabledException = () => flags.enabledManagementExceptionalities
const isEnabledStationHistory = () => flags.enabledStationHistory





const permissionsStore = usePermissionsStore()
const dsAttendanceStore = useDsAttendanceStore()
const router = useRouter()

const scheduleId = computed(() => stationDetails.value?.schedule?.id)

const canAllocateDoctor = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationDoctorPackageAllocating,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const checkSchedulePermission = (permission: AuthorizationPermissions) => {
  if (!scheduleId.value) return false
  return permissionsStore.check({
    permission: permission,
    resource: {
      objectType: AuthorizationResourcesAndSubjects.Schedule,
      objectId: scheduleId.value
    }
  })
}

const canReadExceptionalities = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationExceptionalitiesReading)
)
const canReadHistory = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationEditionHistoricalReading)
)
const canEditStation = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationEditing)
)
const canRemoveDoctor = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationDoctorPackageRemoving)
)
const canReadPaymentRules = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationPaymentRulesReading)
)
const canReadAntecipe = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationAntecipeReading)
)
const canReadScheduleRequirements = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.ScheduleRequerimentReading)
)
const canReadProportionalityRule = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.ScheduleProportionalityRuleReading)
)
const canReadDoctorCheck = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationDoctorCheckReading)
)
// Spec 2026-09-24 §7.1 — a lista de registros exige `attendance_reading` no ds_attendance;
// `canReadDoctorCheck` é permissão de escala e não a implica.
const canReadAttendance = useCanReadAttendance()

const canReadObservations = computed(() =>
  checkSchedulePermission(AuthorizationPermissions.StationObservationsReading)
)

/**
 * "Enviar registro" (M1, balão ⑦). TRÊS condições independentes, com mensagens
 * diferentes de propósito: sem a permissão de EMISSÃO não adianta configurar a
 * escala, com a permissão mas a escala recusando Registro de Atividade o
 * caminho é a política, e com os dois OK falta o plantão ter terminado (Q35) —
 * o tooltip precisa dizer qual dos três é o caso.
 *
 * `checkAnyRessources` e não `check`: as permissões de `ds_attendance` são
 * resolvidas pelo grafo (empresa → unidade → escala) e este modal não conhece o
 * id do recurso `ds_attendance`. É o mesmo caminho que a fila de auditoria já
 * usa em `canRevertValidation`.
 */
const canEmitActivityRecord = computed(() =>
  permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.AttendanceEmitting,
    resourceType: AuthorizationResourcesAndSubjects.DsAttendance
  })
)

const scheduleAcceptsActivityRecords = computed(() => dsAttendanceStore.canSendActivityRecord)

/**
 * RN-07 / RF-12: trava "Alterar/Alocar médico" e o lápis de "Editar Plantão"
 * (variante sem smart allocation) quando o plantão tem avaliação Aprovada —
 * mesma decisão do `update.station.modal`. Sem permissão de leitura do status a
 * avaliação fica `null` e a UI não trava: a barreira real, nesse caso, é o
 * backend (`POST_STATION_EVALUATION_APPROVED`).
 *
 * `evaluation` também desce por prop para o `PostStationDetailsSection`,
 * evitando um segundo GET do mesmo endpoint.
 *
 * Ocupado sem identificação não tem médico a avaliar (a UI mostra "Não
 * avaliado"): sem `stationId` o composable não sonda e evita o 404 inútil.
 * Plantão futuro, em andamento ou sem médico também não sonda (`eligibility`):
 * a avaliação só existe depois do fim do plantão.
 *
 * Com `postStationLock` vindo do consumidor, a instância dele é usada e a
 * sondagem fica com ele (lido uma vez no setup: a prop não troca com o modal
 * montado).
 */
const injectedPostStationLock = props.postStationLock
const {
  isPostStationLocked,
  evaluation: postStationEvaluation,
  canReadPostStation,
  refresh: refreshOwnPostStationLock
} = injectedPostStationLock ??
usePostStationLock(
  () => (isUnidentifiedStation.value ? null : props.infos?.stationId),
  () => scheduleId.value,
  () => ({
    endHour: stationDetails.value?.endHour,
    hasDoctor: !!stationDetails.value?.doctorStation
  })
)
const refreshPostStationLock = () =>
  injectedPostStationLock ? Promise.resolve() : refreshOwnPostStationLock()

const isManagementDoctorModalOpen = ref(false)
const isRemovedDoctorModalOpen = ref(false)
// M5-B — modo inicial do modal de alocação e se o de remoção abre como "Liberar vaga".
const managementInitialCoverage = ref<CoverageMode | null>(null)
const isReleaseMode = ref(false)

const coverageInfo = computed(() => getStationCoverageInfo(stationDetails.value))
const isUnidentifiedStation = computed(
  () => coverageInfo.value.status === CoverageStatus.UNIDENTIFIED
)
// Q30-A: com a flag da escala desligada o estado continua visível, mas não se
// edita o responsável (isso seria marcar de novo); identificar e liberar seguem.
const canEditUnidentifiedResponsible = computed(
  () => canAllocateDoctor.value && canMarkUnidentified(stationDetails.value?.schedule)
)
const showCoverageActions = computed(
  () => props.mode === 'dashboard' && flags.enabledSmartAllocation
)
// `referenceValue` só vem com a feature no BE; sem ele (BE antigo) cai em `value`.
// Os dois nulos → "—" no card, sem inventar zero.
const unidentifiedReferenceValue = computed(
  () => stationDetails.value?.referenceValue ?? stationDetails.value?.value ?? null
)
// Mesmo formatador do badge do tipo (`formattedStationType`); sem tipo → sem rótulo no card.
const unidentifiedStationTypeLabel = computed(() =>
  formatStationTypeLabel(stationDetails.value?.type ?? stationDetails.value?.doctorStation?.type)
)

function openManagement(coverage: CoverageMode | null) {
  managementInitialCoverage.value = coverage
  isManagementDoctorModalOpen.value = true
}

function openRelease() {
  isReleaseMode.value = true
  isRemovedDoctorModalOpen.value = true
}

function closeRemoveDoctorModal() {
  isRemovedDoctorModalOpen.value = false
  isReleaseMode.value = false
}
const isSpeedDialOpen = ref(false)

/**
 * Seção "Tentativas de check": nasce recolhida e só monta o painel no clique do
 * botão do header. O `source` é um computed (e não um objeto literal no
 * template) porque o `CheckAttemptsPanel` observa a prop com `deep: true` — um
 * literal recriado a cada re-render dispararia uma busca nova a cada render.
 */
const showCheckAttempts = ref(false)
const checkAttemptsSectionRef = ref<HTMLElement | null>(null)
const checkAttemptsSource = computed(() => ({ stationId: Number(props.infos?.stationId) }))

// No modo com acordeões a seção fica longe do header (depois de Registro,
// Atividades e Local): ao abrir pelo botão, rola até ela para o clique ter
// efeito visível. `scrollIntoView?.` porque o jsdom dos testes não a implementa.
function toggleCheckAttempts() {
  showCheckAttempts.value = !showCheckAttempts.value
  if (!showCheckAttempts.value) return
  nextTick(() => {
    checkAttemptsSectionRef.value?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' })
  })
}

// Trocar o plantão exibido recolhe a seção: o painel busca por `stationId` e
// deixá-lo aberto mostraria as tentativas do plantão anterior enquanto o novo
// detalhe ainda carrega.
watch(
  () => props.infos?.stationId,
  () => {
    showCheckAttempts.value = false
  }
)

function toggleSpeedDial() {
  isSpeedDialOpen.value = !isSpeedDialOpen.value
}

// M1 (Q23): "Enviar registro" é ação PRIMÁRIA e vem PRIMEIRO. Os três
// pontinhos continuam com Editar/Remover/Histórico — o usuário não precisa
// abrir a edição do plantão para enviar um comprovante.
function handleSpeedDialAction(action: SpeedDialAction) {
  switch (action) {
    case 'send-record':
      // O emit continua saindo (quem monta este modal pode querer reagir), mas o
      // hub de M2 abre AQUI: é neste componente que moram a vaga, a escala e as
      // seções de registro que precisam recarregar depois do envio.
      emit('sendRecord', stationDetails.value)
      openSendRecordModal()
      break
    case 'edit':
      emit('editStation', stationDetails.value)
      break
    case 'history':
      toggleSidebar('history')
      break
    case 'remove':
      isReleaseMode.value = false
      isRemovedDoctorModalOpen.value = true
      break
  }
  isSpeedDialOpen.value = false
}

const isOpenExceptionalitySidebar = ref(false)
const isOpenHistorySidebar = ref(false)
// Alimentado pelo emit do PostStationDetailsSection: a sidebar de pós-plantão
// desliza o modal como as de excepcionalidade e histórico.
const isPostStationSidebarOpen = ref(false)
const stationDetails = ref<ShiftDetails | null>(null)

const exceptionSummary = ref<ExceptionSummary | null>(null)

/**
 * F2 — o registro da vaga por perna (`GET /stations/:id/registration`).
 *
 * `null` tem DOIS significados que a seção trata igual: a rota ainda não foi
 * deployada (o service devolve `null` em 404/405/501) ou o plantão não tem
 * registro nenhum. Nos dois casos a seção cai no render de hoje — a tela nunca
 * quebra por causa de um backend mais antigo que o web.
 */
const stationRegistration = ref<StationRegistrationView | null>(null)
const registrationLoadError = ref<string | null>(null)

/**
 * Trava por perna (backend #3055) do registro acima. Sem registro (rota ausente,
 * sem permissão de leitura de check) = destravado: o backend segue recusando.
 */
const stationLegLock = computed(() => resolveStationLegLock(stationRegistration.value))

const loading = ref(true)
const errorMessage = ref<string | null>(null)
const lastFetchedStationId = ref<number | null>(null)
const observations = ref<DoctorStationObservationListResponse>({ data: [], count: 0 })

const isOpenRequestExceptionality = ref(false)
const isEvidenceModalOpen = ref(false)
const selectedEvidence = ref<CheckEvidence | null>(null)
const selectedEvidenceFiles = ref<CheckEvidence[]>([])
const toast = useToast()
const { notifyError } = useErrorToast()
const loadingDsEvidence = ref(false)
const historyEvents = ref<HistoryEvent[]>([])
const evidenceUploader = ref('')

const evidenceBlobUrl = ref<string | undefined>(undefined)

const isVerificationModalOpen = ref(false)
const verificationCheckId = ref<number | null>(null)

// A verificação (foto de biometria + mapa) é buscada pelo próprio
// `CheckVerificationModal` a partir do id do check — não depende dos anexos
// baixados aqui, que continuam sendo apenas os arquivos da coluna "Evidência".
function openVerification(checkId: number) {
  verificationCheckId.value = checkId
  isVerificationModalOpen.value = true
}

async function fetchHistoryEvents(containerId: number) {
  try {
    const response = await NetworkService.dsAttendance.getAuditTrail(containerId)
    historyEvents.value = mapAuditTrailToHistoryEvents(response.data)
    const uploadEvent = response.data.find(
      (item) => item.actionType === DSAttendanceAuditType.EVIDENCE_UPLOAD
    )
    if (uploadEvent?.updaterUser?.name) {
      evidenceUploader.value = uploadEvent.updaterUser.name
    }
  } catch (error) {
    // Antes só o console sabia: o histórico ficava vazio como se o registro não
    // tivesse eventos, sem distinguir "sem histórico" de "falhou ao buscar".
    console.error('Erro ao buscar histórico do container:', error)
    notifyError(error, 'Não foi possível carregar o histórico do registro de presença.')
  }
}
const exceptionService = new ExceptionService()
const attendanceStatus = ref<{
  hasApprovedRecord: boolean
  containerId?: number
  status?: string
  isOverdue?: boolean
  sourceApp?: string | null
}>({ hasApprovedRecord: false })

/**
 * Mensagem de falha da checagem de presença. Quando preenchida, o alerta de
 * "sem registro aprovado" NÃO é exibido: sem resposta do backend não dá para
 * afirmar que falta registro — o usuário vê o erro e não uma cobrança falsa.
 */
const attendanceStatusError = ref<string | null>(null)

const formattedStartDate = computed(() =>
  formatDate(stationDetails.value?.startHour, stationDetails.value?.timezone)
)
const formattedEndDate = computed(() =>
  formatDate(stationDetails.value?.endHour, stationDetails.value?.timezone)
)

function nameOrEmpty(value?: string | null): string {
  return value || ''
}

function formatDoctorCrm(crm?: { number?: string; uf?: string } | null): string | undefined {
  if (!crm) return undefined
  return `${nameOrEmpty(crm.number)}-${nameOrEmpty(crm.uf)}`
}

// O template montava `${number}-${uf}` inline e, sem CRM, produzia um "-" solto
// sob o nome do médico (o `DoctorInfo` só esconde o subtítulo se ele for falsy,
// e "-" é truthy). String vazia faz o `v-if="subtitle"` esconder a linha.
// Reusa `formatDoctorCrm` em vez de repetir a concatenação.
const doctorCrmLabel = computed(() => {
  const crm = stationDetails.value?.doctorStation?.doctor?.mainCrm
  if (!crm?.number && !crm?.uf) return ''
  return formatDoctorCrm(crm) ?? ''
})

function formatCurrency(value?: number | null): string | undefined {
  if (value == null) return undefined
  return `R$ ${Number(value).toLocaleString('pt-BR')}`
}

function formatRepassMode(inCash?: boolean | null): string | undefined {
  if (inCash == null) return undefined
  return inCash ? 'À vista' : 'Fluxo'
}

function formatAllocatedBy(
  sponsor?: { name?: string; registration?: string | null } | null
): string | undefined {
  if (!sponsor?.name) return undefined
  const suffix = sponsor.registration ? ` #${sponsor.registration}` : ''
  return `${sponsor.name}${suffix}`
}

function formatTimeDetail(time: FormattedDateTime | null): string | undefined {
  if (!time) return undefined
  return `${time.weekday}, ${time.date} às ${time.time}`
}

function formatTimeRange(start: FormattedDateTime | null, end: FormattedDateTime | null): string {
  if (!start || !end) return ''
  return `${start.date} ${start.time} - ${end.date} ${end.time}`
}

function formatTeam(ourTeam?: boolean | null): string {
  return ourTeam ? 'Interno' : 'Externo'
}

const stationContextData = computed(() => {
  if (!stationDetails.value) return undefined
  const sd = stationDetails.value
  const doctor = sd.doctorStation?.doctor
  const crm = doctor?.mainCrm
  const startTime = formattedStartDate.value
  const endTime = formattedEndDate.value
  const sponsor = sd.doctorStation?.userSponsor

  return {
    doctorName: nameOrEmpty(crm?.name),
    doctorCrm: formatDoctorCrm(crm),
    scheduleName: nameOrEmpty(sd.schedule?.name),
    positionName: nameOrEmpty(sd.position?.name),
    shiftName: nameOrEmpty(sd.shift?.name),
    team: formatTeam(sd.doctorStation?.ourTeam),
    timeRange: formatTimeRange(startTime, endTime),
    dutyType: nameOrEmpty(sd.doctorStation?.type),
    value: formatCurrency(sd.value),
    formation: nameOrEmpty(sd.doctorStation?.dsPaymentDoctorFormation?.name),
    repassMode: formatRepassMode(sd.doctorStation?.inCash),
    proportionalityRule: nameOrEmpty(proportionalityRuleTitle.value),
    breadcrumb: [
      sd.schedule?.healthUnit?.company?.name,
      sd.schedule?.healthUnit?.name,
      sd.schedule?.name,
      sd.position?.name
    ]
      .filter(Boolean)
      .join(' > '),
    allocatedBy: formatAllocatedBy(sponsor),
    startDetail: formatTimeDetail(startTime),
    endDetail: formatTimeDetail(endTime),
    timezone: getTimezoneTitle(sd.timezone) || undefined
  }
})

function toggleSidebar(sidebarName: 'history' | 'exceptionality' | 'edit') {
  isSpeedDialOpen.value = false

  const wasHistoryOpen = isOpenHistorySidebar.value
  const wasExceptionalityOpen = isOpenExceptionalitySidebar.value

  isOpenHistorySidebar.value = false
  isOpenExceptionalitySidebar.value = false
  isOpenRequestExceptionality.value = false

  switch (sidebarName) {
    case 'history':
      if (!wasHistoryOpen) {
        isOpenHistorySidebar.value = true
      }
      break
    case 'exceptionality':
      if (!wasExceptionalityOpen) {
        isOpenExceptionalitySidebar.value = true
      }
      break
    case 'edit':
      emit('editStation', stationDetails.value)
      break
  }
}

function handleNewRequest() {
  isOpenExceptionalitySidebar.value = false
  isOpenRequestExceptionality.value = true
}

// Invariante: modal fechado ⇒ nenhuma sidebar filha aberta. As sidebars são
// irmãs do `<ModalVue>` no template, com estado local próprio — esconder o
// modal não as esconde.
function closeAllSidebars() {
  isOpenExceptionalitySidebar.value = false
  isOpenHistorySidebar.value = false
  isOpenRequestExceptionality.value = false
  isPostStationSidebarOpen.value = false
}

const proportionalityRuleTitle = computed(() => {
  if (exceptionSummary.value?.changes.proportionalityRule?.requested) {
    return getProportionalityRuleTitle(
      exceptionSummary.value.changes.proportionalityRule.requested as ProportionalityRuleEnum
    )
  }
  return getProportionalityRuleTitle(stationDetails.value?.schedule?.proportionalityRule)
})

const getTimezoneTitle = (value: string): string | null => {
  const found = timezones.find((tz) => tz.value === value)
  return found ? found.title : null
}

const cards = [
  { formation: 'Residência ano 3', value: 500, repassMode: 'Fluxo' },
  { formation: 'Clínica Médica', value: 450, repassMode: 'Fixo' },
  { formation: 'Pediatria', value: 550, repassMode: 'Variável' }
]

function formatStationTypeLabel(type: string | null | undefined): string | null {
  if (!type) return null
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
}

const formattedStationType = computed(
  () => formatStationTypeLabel(stationDetails.value?.type) ?? 'Aberta'
)

const stationTypeClass = computed(() => {
  switch (stationDetails.value?.type) {
    case 'SEMANAL':
      return 'station-semanal'
    case 'COBERTURA':
      return 'station-cobertura'
    case 'EXTRA':
      return 'station-extra'
    default:
      return 'station-aberta'
  }
})

function close() {
  emit('closeModal')
}

/**
 * As duas flags legadas da escala, só usadas na transição (fonte `SCHEDULE`). `null`
 * quando a escala ainda não chegou: sem elas a linha degrada em vez de estourar.
 */
const scheduleCheckFlags = computed(() => {
  const schedule = stationDetails.value?.schedule
  if (!schedule) return null
  return {
    ourTeam: Boolean(schedule.requiredCheckOurTeam),
    notOurTeam: Boolean(schedule.requiredCheckNotOurTeam)
  }
})

/**
 * M7, balão ⑯: "ver política" / "criar política" leva à escala do plantão já aberta na
 * aba Registro de plantão — um clique entre a pergunta e a resposta. Fecha o modal
 * antes de navegar para o gestor não voltar com o detalhe sobreposto à outra tela.
 */
function openSchedulePolicy() {
  const targetScheduleId = scheduleId.value
  if (!targetScheduleId) return

  close()
  // `useRouter()` em vez de `import { router } from '@/router'`: importar a instância
  // puxa o grafo inteiro de rotas só para navegar daqui, e isso quebra os testes de
  // unidade que montam este modal isoladamente.
  router?.push({
    path: '/gerenciar-escala',
    query: { openScheduleId: String(targetScheduleId), editTab: 'registro-de-plantao' }
  })
}

function handleDeleteObservation(index: number) {
  console.log(index)
}

function formatDate(dateString?: string, timezone: string = '-03:00'): FormattedDateTime | null {
  if (!dateString) return null

  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return null

    const weekday = date.toLocaleDateString('pt-BR', { weekday: 'long', timeZone: timezone })

    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: timezone
    })

    const formattedTime = date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezone
    })

    return {
      weekday: weekday.charAt(0).toUpperCase() + weekday.slice(1),
      date: formattedDate,
      time: formattedTime
    }
  } catch (e) {
    console.error('Error formatting date:', e)
    return null
  }
}

const mainCheck = computed(() => {
  const doctorChecks = stationDetails.value?.doctorStation?.doctorChecks

  const check = doctorChecks?.length === 1 ? doctorChecks[0] : doctorChecks?.find((c) => c.isMain)

  if (!check) return null

  const checkEvidences = check.checkEvidences || []

  return { ...check, originLabel: getCheckOriginLabel(check.origin), checkEvidences }
})

// Decisão de visibilidade (chips + linhas de vínculo) extraída como função pura
// testada (`getPermanenceVisibility`, tests/unit/permanence-utils.spec.ts) em
// vez de `&&` inline no template — este arquivo não tem mount test (ver
// "Notas de divergência" #6 do plano), então o cenário de flag desligada só
// fica coberto se a decisão em si for uma função pura.
const permanenceVisibility = computed(() =>
  getPermanenceVisibility(flags.enabledPermanenceRecord, mainCheck.value)
)

const isConciliationOrigin = computed(
  () => mainCheck.value?.origin === 'FOLHA' || mainCheck.value?.origin === 'EXTERNAL_APP'
)

/**
 * Feature detection do pacote de acordeões (§8.1 + I19). O sinal é a resposta de
 * `GET /stations/:id/registration`: com ela, o Registro de Plantão já é o render
 * por perna e "Local e biometria" deixou de ser coluna dele — os sete blocos
 * fazem sentido. Sem ela (404 do backend antigo, ou sem permissão de leitura do
 * check) o Detalhes do Plantão é EXATAMENTE o de hoje, pixel a pixel: o pacote
 * entra inteiro ou não entra.
 */
const hasRegistrationAccordions = computed(() => !!stationRegistration.value)

/**
 * Pós-plantão, Excepcionalidade e Observações em acordeão: com o pacote §8.1 (I19)
 * como hoje, OU no celular — lá a tela é longa e toda seção vira acordeão (R6).
 * "Local e biometria" e "Tentativas de check" seguem só com o pacote: sem ele, a
 * biometria é coluna do Registro de Plantão e virar bloco próprio a duplicaria.
 */
const useAccordions = computed(() => hasRegistrationAccordions.value || isFullScreen.value)

/**
 * Pós-plantão em acordeão. Com o pacote §8.1 segue como hoje (desktop intacto); no
 * celular só quando o gestor pode ler o pós-plantão (flag + permissão) — sem isso
 * o `PostStationDetailsSection` não renderiza nada e o acordeão ficaria vazio.
 */
const showPostStationAccordion = computed(
  () => hasRegistrationAccordions.value || (isFullScreen.value && canReadPostStation.value)
)

/**
 * Valor exibido pelo `ValueDetailsSection` no dashboard: o excepcional quando há
 * excepcionalidade com valor, senão o do plantão. O resumo do celular usa o mesmo.
 */
const valuePanelOriginalValue = computed(() =>
  props.mode === 'dashboard' && exceptionSummary.value?.financials?.totalExceptionalValue != null
    ? Number(exceptionSummary.value.financials.totalExceptionalValue)
    : stationDetails.value?.value
)

/**
 * Há algo legível no painel de valores (mesmas permissões do `ValueDetailsSection`)?
 * Sem isso, no celular o acordeão "Valores do plantão" não aparece (só o painel vazio,
 * como no desktop).
 */
const hasReadableValues = computed(() => {
  if (canReadPaymentRules.value) return true
  const ds = stationDetails.value?.doctorStation
  return canReadAntecipe.value && !!(ds?.requestAntecipe || ds?.antecipeWasPaid)
})

/** Rótulos do status da excepcionalidade — os mesmos do `StatusBadge` da sidebar. */
const EXCEPTION_STATUS_LABELS: Record<ExceptionStatusEnum, string> = {
  [ExceptionStatusEnum.AWAITING_APPROVAL]: 'Em andamento',
  [ExceptionStatusEnum.APPROVED]: 'Aprovado',
  [ExceptionStatusEnum.REJECTED]: 'Reprovado',
  [ExceptionStatusEnum.REVERTED]: 'Revertido',
  [ExceptionStatusEnum.CANCELED]: 'Cancelado'
}

/** Resumo de "Valores do plantão": só com a permissão; mesmo texto do painel sem valor. */
const valuesSummary = computed(() =>
  canReadPaymentRules.value
    ? (formatCurrency(valuePanelOriginalValue.value) ?? 'Não calculado')
    : undefined
)

const exceptionalitySummaryLabel = computed(() => {
  const status = exceptionSummary.value?.status
  return status ? (EXCEPTION_STATUS_LABELS[status] ?? status) : undefined
})

/** Resumos dos cabeçalhos dos acordeões no celular. */
const mobileSummaries = computed(() => {
  const sd = stationDetails.value
  const status = postStationEvaluation.value?.consolidatedStatus as PostStationStatus | undefined
  const observationCount = observations.value.data.length
  return {
    doctor: isUnidentifiedStation.value
      ? 'Sem identificação'
      : sd?.doctorStation?.doctor?.mainCrm?.name || 'Vaga aberta',
    values: valuesSummary.value,
    locationBiometry: mainCheck.value ? undefined : 'pendente',
    postStation: status ? (STATUS_CONFIG[status] ?? UNKNOWN_STATUS_CONFIG).label : 'Não avaliado',
    exceptionality: exceptionalitySummaryLabel.value,
    observations: observationCount ? String(observationCount) : undefined
  }
})

/** Botão da coluna "Local e biometria" — mesma regra pura do render antigo. */
const verificationButtonState = computed(() => getVerificationButtonState(mainCheck.value))

/**
 * Qual container venceu cada perna. Sai do registro por perna e desce para os
 * cards: um Registro de Atividade APROVADO pode ter perdido o ranking para a
 * folha, então "venceu a perna de X" nunca pode ser deduzido do status do card.
 */
const activityWinningLegs = computed(() => {
  const legs = stationRegistration.value?.raw?.legs
  return {
    checkin: legs?.checkin?.source?.dsAttendanceContainerId ?? null,
    checkout: legs?.checkout?.source?.dsAttendanceContainerId ?? null
  }
})

/** Resumo de uma linha da excepcionalidade — o detalhe continua na sidebar. */
const exceptionalitySummaryText = computed(() => {
  const summary = exceptionSummary.value
  if (!summary) return ''
  const requester = summary.requester?.name ? ` · solicitada por ${summary.requester.name}` : ''
  return `Excepcionalidade ${summary.status}${requester}.`
})

// Gate do "Registro de plantão" e do alerta de presença: antes do início
// teórico não existe registro a exibir nem a cobrar.
const hasStationStarted = computed(() => hasInstantPassed(stationDetails.value?.startHour))

// Só decide o TEXTO do check-out ausente (não gateia nada): plantão em andamento
// mostra "Aguardando", plantão encerrado mostra "Não registrado". Plantão sem
// `endHour` fica em "Aguardando" — mesmo default documentado de `hasInstantPassed`.
const hasStationEnded = computed(() => hasInstantPassed(stationDetails.value?.endHour))

/**
 * Variante do menu de ações. `none` fora do dashboard (Aprovações) ou sem plantão:
 * os blocos do template já não renderizam nesses casos, e o dock do celular some.
 */
const actionsVariant = computed<StationDetailActionsVariant>(() => {
  if (!stationDetails.value || props.mode !== 'dashboard') return 'none'
  return flags.enabledSmartAllocation ? 'smart' : 'legacy'
})

/**
 * Condições de visibilidade/habilitação/motivo das ações (§9 da spec do mobile). O
 * template desktop lê `actionMap`/`isOverflowAvailable`; o dock do celular lê
 * `stationActions`. Aqui, depois de `hasStationEnded`: as fontes precisam existir.
 */
const {
  actions: stationActions,
  actionMap,
  isOverflowAvailable,
  isSendRecordDisabled,
  sendRecordTooltip
} = useStationDetailActions(
  {
    variant: actionsVariant,
    hasDoctor: () => !!stationDetails.value?.doctorStation?.doctor,
    isUnidentified: isUnidentifiedStation,
    ourTeam: () => !!stationDetails.value?.doctorStation?.ourTeam,
    canAllocateDoctor,
    canEditStation,
    canRemoveDoctor,
    canReadHistory,
    canReadExceptionalities,
    exceptionalitiesEnabled: () => isEnabledException(),
    stationHistoryEnabled: () => isEnabledStationHistory(),
    isPostStationLocked,
    // Trava por perna: lida do registro que este modal já carrega (sem rota nova).
    isLegLocked: () => stationLegLock.value.locked,
    legLockReason: () => stationLegLock.value.reason,
    canEmitActivityRecord,
    scheduleAcceptsActivityRecords,
    hasStationEnded,
    isExceptionalityOpen: isOpenExceptionalitySidebar,
    isHistoryOpen: isOpenHistorySidebar,
    isCheckAttemptsOpen: showCheckAttempts
  },
  // Na variante legada o lápis e o histórico passam por `toggleSidebar` (fecham as
  // outras sidebars); na smart, pelo speed dial — exatamente como os botões de antes.
  // Handler só existe com a variante `smart`/`legacy` (em `none` a lista é vazia).
  {
    allocate: () => openManagement(null),
    edit: () =>
      actionsVariant.value === 'legacy' ? toggleSidebar('edit') : handleSpeedDialAction('edit'),
    sendRecord: () => handleSpeedDialAction('send-record'),
    exceptionality: () => toggleSidebar('exceptionality'),
    checkAttempts: () => toggleCheckAttempts(),
    history: () =>
      actionsVariant.value === 'legacy'
        ? toggleSidebar('history')
        : handleSpeedDialAction('history'),
    remove: () => handleSpeedDialAction('remove')
  }
)

/** Tela cheia só no dashboard: em Aprovações o detalhe divide a tela com a sidebar externa. */
const isFullScreen = computed(() => props.mobileShell && props.mode === 'dashboard')

/**
 * Detalhe pronto para o cabeçalho e o dock do celular. `fetchStationDetails` não zera
 * `stationDetails` ao recarregar (alocação, remoção, registro enviado, volta do Editar)
 * nem no erro: sem este gate, meta, selos e dock mostrariam — e agiriam sobre — o
 * plantão anterior enquanto o corpo está no skeleton ou na mensagem de erro.
 * Só o celular lê: o menu do desktop segue `actionsVariant`.
 */
const isDetailReady = computed(
  () => !loading.value && !errorMessage.value && !!stationDetails.value
)

/** Meta do cabeçalho em tela cheia: "#id · dia · início–fim · escala · unidade". */
const mobileMeta = computed(() => {
  const sd = stationDetails.value
  if (!sd || !isDetailReady.value) return undefined
  const start = formattedStartDate.value
  const end = formattedEndDate.value
  return [
    `#${sd.id}`,
    start ? `${start.weekday}, ${start.date}` : null,
    start && end ? `${start.time}–${end.time}` : null,
    sd.schedule?.name,
    sd.schedule?.healthUnit?.name
  ]
    .filter(Boolean)
    .join(' · ')
})

const mobileBadges = computed<MobileBadge[]>(() => {
  const sd = stationDetails.value
  if (!sd || !isDetailReady.value) return []
  const badges: MobileBadge[] = [
    { id: 'type', label: formattedStationType.value, class: stationTypeClass.value }
  ]
  if (sd.sector?.name)
    badges.push({ id: 'sector', label: sd.sector.name, class: 'station-badge-neutral' })
  if (sd.specialty?.name) {
    badges.push({ id: 'specialty', label: sd.specialty.name, class: 'station-badge-neutral' })
  }
  if (sd.doctorStation?.doctor && sd.doctorStation.ourTeam === false) {
    badges.push({ id: 'external', label: 'Externo', class: 'station-badge-external' })
  }
  return badges
})

const showDoctorCheck = computed(() =>
  Boolean(
    stationDetails.value?.doctorStation?.doctorChecks &&
    stationDetails.value?.doctorStation?.doctorChecks.length > 0
  )
)

const checkin = computed(() => {
  const raw = mainCheck.value?.checkin
  return raw ? formatDate(raw, stationDetails?.value?.timezone) : null
})

const checkout = computed(() => {
  const raw = mainCheck.value?.checkout
  return raw ? formatDate(raw, stationDetails?.value?.timezone) : null
})

const formattedObservations = computed(() =>
  observations.value.data.map((obs) => {
    // Sem `createdAt` a data simplesmente não existe — "Data inválida" acusava um
    // erro de dado que não aconteceu. O texto de erro fica reservado ao catch,
    // onde a data existe mas não pôde ser formatada.
    let correctedTimestamp = 'Data não disponível'

    if (obs.createdAt) {
      try {
        const utcDate = new Date(obs.createdAt)
        const timezone = stationDetails.value?.timezone || '-03:00'
        const offsetHours = parseInt(timezone.split(':')[0], 10)
        const localDate = addHours(utcDate, offsetHours)

        correctedTimestamp = format(localDate, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
      } catch (e) {
        console.error('Erro ao formatar o timestamp da observação:', e)
        correctedTimestamp = 'Data inválida'
      }
    }

    return {
      id: obs.id,
      author: obs.author.name,
      authorId: obs.author.id,
      timestamp: correctedTimestamp,
      text: obs.text
    }
  })
)

const baseHourlyRate = computed(() => {
  if (
    exceptionSummary.value?.changes.hourlyValue.requested &&
    exceptionSummary.value?.financials.exceptionalDurationHours
  ) {
    const cost = Number(exceptionSummary.value.changes.hourlyValue.requested)
    const duration = Number(exceptionSummary.value.financials.exceptionalDurationHours)
    if (duration > 0) {
      return cost / duration
    }
    return cost
  }

  if (
    !stationDetails.value ||
    !stationDetails.value.value ||
    !stationDetails.value.startHour ||
    !stationDetails.value.endHour
  ) {
    return 0
  }

  const start = new Date(stationDetails.value.startHour)
  const end = new Date(stationDetails.value.endHour)

  const durationInHours = differenceInHours(end, start)

  if (durationInHours <= 0) {
    return stationDetails.value.value
  }

  return stationDetails.value.value / durationInHours
})

async function fetchExceptionDetails(
  doctorStationId: number | undefined,
  exceptionStatus: string | null | undefined,
  exceptionRequestId: any
) {
  if (!doctorStationId || !exceptionStatus || !exceptionRequestId) {
    exceptionSummary.value = null
    return
  }

  try {
    exceptionSummary.value = await exceptionService.getDetails(exceptionRequestId)
  } catch (exceptionErr: any) {
    console.warn('Erro ao carregar detalhes da exceção:', exceptionErr)
    exceptionSummary.value = null
  }
}

async function fetchObservationsAndAttendance(
  doctorStationId: number | undefined,
  startHour: string | undefined
) {
  if (!doctorStationId) {
    observations.value = { data: [], count: 0 }
    return
  }

  observations.value = await NetworkService.observation.list(doctorStationId)

  if (!flags.enabledDsAttendancePolicy) return

  const stationDate = startHour ? new Date(startHour).toISOString().slice(0, 10) : null
  if (stationDate) {
    // Isolado do restante do carregamento de propósito: a checagem de presença é
    // secundária e não pode derrubar o modal inteiro. O erro fica visível na seção
    // (`attendanceStatusError`) em vez de o service devolver "sem registro aprovado",
    // que destravaria a edição do plantão por falha de rede.
    attendanceStatusError.value = null
    try {
      attendanceStatus.value = await NetworkService.dsAttendance.getStatusByStation(
        doctorStationId,
        stationDate
      )
    } catch (error) {
      console.error('Erro ao verificar o registro de presença do plantão:', error)
      attendanceStatus.value = { hasApprovedRecord: false }
      attendanceStatusError.value = getApiErrorMessage(
        error,
        'Não foi possível verificar o registro de presença deste plantão.'
      )
    }
  }
}

/**
 * Isolada do restante do carregamento pelo mesmo motivo da checagem de presença:
 * uma falha aqui vira estado DENTRO da seção (balão ⑥), nunca um modal vazio.
 */
/**
 * O registro agora também gateia ações (trava por perna). Dois cuidados:
 * - resposta atrasada de um plantão anterior é descartada (`registrationRequestSeq`);
 * - ao trocar de doctorStation o registro anterior é zerado na hora, para a trava
 *   dele nunca valer para o novo. No recarregamento do MESMO doctorStation (retry,
 *   envio de registro concluído) o atual fica até a resposta, sem piscar a seção.
 */
let registrationRequestSeq = 0
let registrationDoctorStationId: number | null = null

async function fetchStationRegistration(doctorStationId?: number) {
  const seq = ++registrationRequestSeq
  const id = doctorStationId ?? stationDetails.value?.doctorStation?.id
  if (!id || !canReadDoctorCheck.value) {
    stationRegistration.value = null
    registrationDoctorStationId = null
    return
  }

  if (registrationDoctorStationId !== Number(id)) {
    stationRegistration.value = null
    registrationDoctorStationId = Number(id)
  }
  registrationLoadError.value = null
  try {
    const registration = await NetworkService.station.getStationRegistration(Number(id))
    if (seq !== registrationRequestSeq) return
    stationRegistration.value = registration
  } catch (error) {
    if (seq !== registrationRequestSeq) return
    console.error('Erro ao carregar o registro do plantão:', error)
    stationRegistration.value = null
    registrationLoadError.value = getApiErrorMessage(
      error,
      'Não foi possível carregar o registro deste plantão.'
    )
  }
}

/* --------------------------------------------------------------------------- *
 * F4 — "Ver evidências": o modal com uma aba por perna
 * --------------------------------------------------------------------------- */

const isStationEvidenceModalOpen = ref(false)
const stationEvidenceContext = ref<StationEvidenceContext | null>(null)

/**
 * O contexto chega PRONTO da seção — só ela sabe qual fonte venceu cada perna e
 * onde essa fonte mora. O roteamento por tipo de fonte (folha, app, Registro de
 * Atividade) mora dentro do modal, junto dos painéis que o exibem.
 */
function openStationEvidence(context: StationEvidenceContext) {
  stationEvidenceContext.value = context
  isStationEvidenceModalOpen.value = true
}

// Trocar de plantão com o modal aberto mostraria a evidência do plantão anterior.
watch(
  () => [props.infos?.stationId, stationRegistration.value],
  () => {
    isStationEvidenceModalOpen.value = false
    stationEvidenceContext.value = null
  }
)

/* --------------------------------------------------------------------------- *
 * M2 — "Enviar registro" (SendRecordModal da W4)
 * --------------------------------------------------------------------------- */

const isSendRecordModalOpen = ref(false)
const activityRecordsSectionRef = ref<{ fetchRecords: () => Promise<void> } | null>(null)

/** Wizard de folha aberto pelo passo 1 do SendRecordModal, com o handoff da vaga (C6). */
const isAttendanceUploadModalOpen = ref(false)
const sheetInitialForm = ref<Partial<DsAttendanceUploadForm> | null>(null)
const sheetLockedFields = ref<string[]>([])

function openSendRecordModal() {
  if (isSendRecordDisabled.value) return
  isSendRecordModalOpen.value = true
}

/**
 * Perna que o registro da vaga ainda não tem. `null` quando as duas já têm fonte
 * (ou quando o backend de registro ainda não responde) — o modal decide sozinho
 * nesse caso.
 */
const missingRegistrationLegs = computed<CoveredLegs | null>(() => {
  const registration = stationRegistration.value
  if (!registration) return null

  const hasCheckin = !!registration.checkin?.value
  const hasCheckout = !!registration.checkout?.value
  if (!hasCheckin && !hasCheckout) return CoveredLegs.BOTH
  if (!hasCheckin) return CoveredLegs.CHECKIN
  if (!hasCheckout) return CoveredLegs.CHECKOUT
  return null
})

/**
 * Contexto da vaga de origem (§2 de M2). `null` enquanto o detalhe não carregou
 * ou a vaga não tem alocação: sem `doctorStationId` não há registro a enviar, e
 * o modal nem é montado.
 *
 * "Adicionar outros plantões" (passo 2) não depende deste contexto (BF16): o
 * próprio `SendRecordModal` busca os candidatos do médico via
 * `getActivityRecordCandidates` a partir do `doctorStationId` — o Detalhes do
 * Plantão só conhece a vaga de origem, e nunca populou esse campo.
 */
function buildSendRecordStation(sd: ShiftDetails, doctorStationId: number) {
  return {
    doctorStationId,
    referenceDate: sd.startHour ?? null,
    expectedStart: sd.startHour ?? null,
    expectedEnd: sd.endHour ?? null,
    doctorName: sd.doctorStation?.doctor?.mainCrm?.name ?? null,
    scheduleName: sd.schedule?.name ?? null,
    healthUnitName: sd.schedule?.healthUnit?.name ?? null,
    shiftName: sd.shift?.name ?? null,
    shiftId: sd.shift?.id ?? null,
    registrationStatus: stationRegistration.value?.status ?? null,
    missingLegs: missingRegistrationLegs.value
  }
}

const sendRecordContext = computed<SendRecordContext | null>(() => {
  const sd = stationDetails.value
  const doctorStationId = Number(sd?.doctorStation?.id ?? 0)
  if (!sd || !doctorStationId) return null

  const settings = dsAttendanceStore.registrationSettings
  const healthUnit = sd.schedule?.healthUnit

  return {
    doctorStationId,
    scheduleId: Number(sd.schedule?.id ?? 0),
    companyId: healthUnit?.company?.id ?? null,
    healthUnitId: healthUnit?.id ?? null,
    referenceDate: sd.startHour ?? null,
    station: buildSendRecordStation(sd, doctorStationId),
    acceptedActivityTypes: settings.acceptedActivityTypes,
    checkinLateToleranceMinutes: settings.checkinLateToleranceMinutes,
    checkoutEarlyToleranceMinutes: settings.checkoutEarlyToleranceMinutes,
    // A config aqui é buscada COM o `scheduleId` da vaga, então a modalidade que
    // viaja é a da política desta escala — é ela que decide se o passo 1 ainda
    // pode oferecer "Registro de Plantão".
    policyMonitoringType: settings.monitoringType ?? null,
    hasSheetRuleInEffect: settings.hasSheetRuleInEffect ?? null
  }
})

/**
 * Envio concluído: as duas seções de registro desta tela ficam desatualizadas na
 * hora. Recarrega o registro por perna (W2) e a lista de Registros de Atividade
 * da vaga, sem refazer o `GET /stations/:id` inteiro.
 */
async function handleSendRecordSaved() {
  await Promise.all([
    fetchStationRegistration(),
    activityRecordsSectionRef.value?.fetchRecords() ?? Promise.resolve()
  ])
}

/**
 * "Registro de Plantão" no passo 1 (C6). O wizard de folha abre AQUI mesmo, com o
 * `buildSheetHandoff` traduzindo o payload da vaga em `initialForm`/`lockedFields`.
 *
 * Antes esta função descartava o payload e abria a fila em nova aba: o usuário caía num
 * formulário em branco e tinha de redigitar empresa, unidade, data e escala que a tela já
 * conhecia — e uma divergência ali gera folha para o plantão errado. Abrir localmente
 * também preserva o que estiver aberto no Dashboard, que era a razão da nova aba.
 */
function handleRedirectToSheet(payload: RedirectToSheetPayload) {
  const handoff = buildSheetHandoff(payload)
  sheetInitialForm.value = handoff.form
  sheetLockedFields.value = handoff.lockedFields
  isSendRecordModalOpen.value = false
  isAttendanceUploadModalOpen.value = true
}

async function fetchStationDetails() {
  const stationId = props.infos?.stationId
  if (!stationId) {
    stationDetails.value = null
    exceptionSummary.value = null
    stationRegistration.value = null
    registrationLoadError.value = null
    // Invalida um registro ainda em voo do plantão anterior.
    registrationRequestSeq++
    registrationDoctorStationId = null
    return
  }

  loading.value = true
  errorMessage.value = null

  try {
    const res = await NetworkService.station.getStationDetails(stationId)

    stationDetails.value = res
    lastFetchedStationId.value = stationId

    const doctorStationId = res?.doctorStation?.id
    const exceptionStatus = res?.doctorStation?.exceptionSummaryStatus
    const exceptionRequestId = props.exceptionIdSelected ?? res?.doctorStation?.approvedExceptionId

    await fetchExceptionDetails(doctorStationId, exceptionStatus, exceptionRequestId)
    // Em paralelo: a sondagem de pós-plantão não depende de observações nem de
    // presença, e precisa estar resolvida antes de `loading` virar false — ela
    // alimenta o `PostStationDetailsSection` e a trava de edição; decidir depois
    // faria o painel de pós-plantão trocar de estado na cara do usuário.
    //
    // Depois de `stationDetails.value = res` de propósito: a `scheduleId` que
    // gateia a leitura sai do detalhe do plantão, então sondar antes não passaria
    // do gate de permissão.
    await Promise.all([
      fetchObservationsAndAttendance(doctorStationId, res?.startHour),
      refreshPostStationLock(),
      fetchStationRegistration(doctorStationId),
      // Config de registro da ESCALA deste plantão: decide se "Enviar registro"
      // fica habilitado. A ação nunca lança (default seguro no store).
      dsAttendanceStore.fetchRegistrationSettings(res?.schedule?.id)
    ])
  } catch (err: any) {
    // Estado de erro visível no corpo do modal — com a mensagem específica do
    // ServiceError (permissão, rede, timeout...) em vez do texto fixo.
    errorMessage.value = getApiErrorMessage(
      err,
      'Não foi possível carregar os detalhes do plantão.'
    )
    console.error(err)
  } finally {
    loading.value = false

    // Deep-link (#1550): no Dashboard o modal é o dono das sidebars e abre a
    // `ExceptionalitiesSidebar` sozinho. Nas Aprovações (`mode === 'approvals'`)
    // a página já abre a própria Request/Summary por fora (`isPushedExternally`);
    // abrir também a interna empilhava uma sidebar duplicada, escondida atrás da
    // externa, com duas chamadas de API redundantes — e era ela que "sobrava"
    // na tela após aprovar/recusar.
    if (
      props.mode !== 'approvals' &&
      props.exceptionIdSelected &&
      stationDetails.value?.doctorStation
    ) {
      nextTick(() => {
        // Reconfere no callback: se o consumidor escondeu o modal enquanto o
        // fetch estava em voo, `closeAllSidebars()` já rodou e este tick
        // pendente não pode reabrir a sidebar por cima de um modal invisível.
        if (props.showModal) isOpenExceptionalitySidebar.value = true
      })
    }
  }
}

watch(
  () => props.showModal,
  (isModalVisible) => {
    if (isModalVisible) {
      if (props.infos?.stationId) {
        fetchStationDetails()
      } else {
        stationDetails.value = null
        loading.value = false
      }
      return
    }
    // Modal escondido por prop pelo consumidor (sem passar pelo `close()`
    // interno) — é o que a página de Aprovações faz ao aprovar/recusar. Sem este
    // reset, a `ExceptionalitiesSidebar` aberta pelo `exceptionIdSelected` (e a
    // Summary dentro dela) ficava visível sobre a página com o modal invisível.
    closeAllSidebars()
  },
  // immediate: true para tratar mudanças de showModal que chegam enquanto fetch
  // está em voo, evitando reabrir sidebars sobre um modal invisível
  { immediate: true }
)

// Cobre só a troca "por baixo" do stationId com o modal já aberto (ex.: clique
// na linha de vínculo de Registro de Permanência, que atualiza `stationSelected`
// no consumidor sem fechar/reabrir este modal) — a abertura inicial já é
// tratada pelo watch de `props.showModal` acima.
watch(
  () => props.infos?.stationId,
  (newStationId, oldStationId) => {
    if (shouldRefetchOnStationIdChange(props.showModal, newStationId, oldStationId)) {
      fetchStationDetails()
    }
  }
)

function revokeEvidenceBlobUrl() {
  if (evidenceBlobUrl.value?.startsWith('blob:')) {
    URL.revokeObjectURL(evidenceBlobUrl.value)
  }
  evidenceBlobUrl.value = undefined
  // Revoga blob URLs criadas em `openEvidence` para evidências de check
  // (cada arquivo é baixado via endpoint streaming e ganha sua própria
  // blob URL no `path`).
  selectedEvidenceFiles.value.forEach((file) => {
    if (file.path?.startsWith('blob:')) {
      URL.revokeObjectURL(file.path)
    }
  })
}

async function openEvidence(files: CheckEvidence[]) {
  if (!files.length) return
  const stationId = props.infos?.stationId
  if (!stationId) return
  revokeEvidenceBlobUrl()
  loadingDsEvidence.value = true
  let failedCount = 0
  try {
    // O `path` em `CheckEvidence` agora é um token cifrado pelo backend;
    // baixamos cada evidência via endpoint streaming autenticado e
    // substituímos o `path` por uma blob URL local — assim o
    // `EvidenceModal`/`StepPreview` continuam recebendo um URL plotável.
    const downloadable = await Promise.all(
      files.map(async (file) => {
        if (!file.id) return file
        try {
          const blob = await NetworkService.doctorCheckEvidence.downloadCheckEvidenceFile(
            stationId,
            file.id
          )
          return { ...file, path: URL.createObjectURL(blob), type: blob.type }
        } catch (err) {
          console.error(`Falha ao baixar evidência ${file.id}:`, err)
          failedCount += 1
          // Substitui o token cifrado por string vazia para impedir que o
          // `StepPreview` tente abrir o token como URL e mostre lixo.
          return { ...file, path: '' }
        }
      })
    )
    if (failedCount === files.length) {
      toast.error('Não foi possível carregar a evidência. Tente novamente em instantes.')
      return
    }
    if (failedCount > 0) {
      toast.warning(`Não foi possível carregar ${failedCount} arquivo(s) de evidência.`)
    }
    // A coluna "Evidência" agora só trata anexos: a heurística que desviava
    // checks do app para o modal de biometria saiu junto com o
    // `BiometryEvidenceModal` — a biometria tem coluna e modal próprios.
    selectedEvidence.value = downloadable[0]
    selectedEvidenceFiles.value = downloadable
    historyEvents.value = []
    evidenceUploader.value = downloadable[0].uploadedBy?.name ?? ''
    isEvidenceModalOpen.value = true
    const containerId = attendanceStatus.value.containerId
    if (containerId) fetchHistoryEvents(containerId)
  } finally {
    loadingDsEvidence.value = false
  }
}

async function openDsAttendanceEvidence(containerIdOverride: number | null = null) {
  const containerId = containerIdOverride ?? attendanceStatus.value.containerId
  if (!containerId) return
  revokeEvidenceBlobUrl()
  loadingDsEvidence.value = true
  try {
    const [blob, detail] = await Promise.all([
      NetworkService.dsAttendance.downloadEvidenceFile(containerId),
      NetworkService.dsAttendance.getById(containerId).catch(() => null)
    ])
    const blobUrl = URL.createObjectURL(blob)
    evidenceBlobUrl.value = blobUrl
    const evidence: CheckEvidence = {
      name: detail?.sheetFilename || 'Folha de monitoramento.pdf',
      path: blobUrl,
      type: blob.type
    }
    selectedEvidence.value = evidence
    selectedEvidenceFiles.value = [evidence]
    evidenceUploader.value = ''
    isEvidenceModalOpen.value = true
    fetchHistoryEvents(containerId)
  } catch (e) {
    // Antes o clique simplesmente não fazia nada: a falha morria no console. Endpoint
    // `blob` — com o unwrap no service, o motivo real chega ao usuário.
    console.error('Erro ao buscar evidência do registro de presença:', e)
    notifyError(e, 'Não foi possível carregar a evidência do registro de presença.')
  } finally {
    loadingDsEvidence.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DashboardModalShell, {
      open: _ctx.showModal,
      "full-screen": isFullScreen.value,
      title: "Detalhes do Plantão",
      meta: mobileMeta.value,
      "test-id": "station-details-panel",
      onClose: close,
      hasHeaderBorder: true,
      hasFooterBorder: true,
      class: _normalizeClass({
      'modal-pushed-by-sidebar':
        _ctx.isPushedExternally ||
        isOpenExceptionalitySidebar.value ||
        isOpenRequestExceptionality.value ||
        isOpenHistorySidebar.value ||
        isPostStationSidebarOpen.value
    }),
      "min-height": '40vh'
    }, _createSlots({
      header: _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createBlock(StationDetailsHeaderSkeleton, { key: 0 }))
          : (stationDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(StationIdBadge, {
                    stationId: stationDetails.value?.id,
                    doctorStationId: stationDetails.value?.doctorStation?.id
                  }, null, 8, ["stationId", "doctorStationId"]),
                  _hoisted_3
                ]),
                _createElementVNode("span", _hoisted_4, _toDisplayString(stationDetails.value?.schedule?.healthUnit?.company?.name || 'Empresa não informada') + " > " + _toDisplayString(stationDetails.value?.schedule?.healthUnit?.name || 'Unidade não informada') + " > " + _toDisplayString(stationDetails.value?.schedule?.name || 'Escala não informada') + " > " + _toDisplayString(stationDetails.value?.position?.name || 'Posição não definida'), 1)
              ]))
            : _createCommentVNode("", true),
        (loading.value || (stationDetails.value && _ctx.mode === 'dashboard' && _unref(flags).enabledSmartAllocation))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (loading.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(actionMap).allocate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createElementVNode("button", {
                            "data-testid": "station-details-allocate-doctor-button",
                            disabled: _unref(actionMap).allocate.disabled,
                            title: isUnidentifiedStation.value ? 'Identificar médico' : undefined,
                            "aria-label": isUnidentifiedStation.value ? 'Identificar médico' : undefined,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(actionMap).allocate.handler())),
                            class: "w-12 h-12 rounded-full bg-primary flex items-center justify-center shadow-md hover:bg-primary40 focus:outline-none focus:ring-2 focus:ring-primary30 focus:ring-opacity-75 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary"
                          }, [
                            (stationDetails.value?.doctorStation.doctor)
                              ? (_openBlock(), _createBlock(AccountSwitchIcon, {
                                  key: 0,
                                  color: "white",
                                  class: "w-[18px] h-[18px]"
                                }))
                              : (_openBlock(), _createBlock(AccountPlus, {
                                  key: 1,
                                  color: "white",
                                  class: "w-[18px] h-[18px]"
                                }))
                          ], 8, _hoisted_7),
                          (_unref(actionMap).allocate.disabled)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                activator: "parent",
                                location: "top",
                                text: _unref(actionMap).allocate.disabledReason
                              }, null, 8, ["text"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(actionMap)['send-record'])
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          "data-testid": "station-details-send-record",
                          disabled: _unref(actionMap)['send-record'].disabled,
                          title: _unref(sendRecordTooltip),
                          class: "w-12 h-12 rounded-full border-2 border-solid border-primary30 bg-white flex items-center justify-center shadow-md hover:bg-primary5 focus:outline-none focus:ring-2 focus:ring-primary30 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(actionMap)['send-record'].handler()))
                        }, [
                          _createVNode(SVGIcon, {
                            path: _unref(mdiUpload),
                            "aria-hidden": "true",
                            class: "w-[18px] h-[18px] text-primary30"
                          }, null, 8, ["path"])
                        ], 8, _hoisted_8))
                      : _createCommentVNode("", true),
                    (_unref(actionMap).exceptionality)
                      ? (_openBlock(), _createBlock(PadlockButton, {
                          key: 2,
                          status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                          "is-active": isOpenExceptionalitySidebar.value,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(actionMap).exceptionality.handler())),
                          loading: loading.value
                        }, null, 8, ["status", "is-active", "loading"]))
                      : _createCommentVNode("", true),
                    (_unref(actionMap)['check-attempts'])
                      ? (_openBlock(), _createBlock(CheckAttemptsButton, {
                          key: 3,
                          "test-id": "station-details-check-attempts-toggle",
                          "is-active": showCheckAttempts.value,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(actionMap)['check-attempts'].handler()))
                        }, null, 8, ["is-active"]))
                      : _createCommentVNode("", true),
                    (_unref(isOverflowAvailable))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", {
                            "data-testid": "station-details-speed-dial-toggle",
                            onClick: toggleSpeedDial,
                            class: "w-12 h-12 rounded-full border-2 border-solid border-primary30 flex items-center justify-center shadow-md bg-white cursor-pointer"
                          }, [
                            _createVNode(DotsHorizontal, {
                              color: "#2F7F91",
                              class: _normalizeClass(["w-[18px] h-[18px] transition-transform duration-200", { 'rotate-90': isSpeedDialOpen.value }])
                            }, null, 8, ["class"])
                          ]),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-200",
                            "enter-from-class": "transform opacity-0 scale-95 -translate-y-2",
                            "enter-to-class": "transform opacity-100 scale-100 translate-y-0",
                            "leave-active-class": "transition ease-in duration-150",
                            "leave-from-class": "transform opacity-100 scale-100 translate-y-0",
                            "leave-to-class": "transform opacity-0 scale-95 -translate-y-2"
                          }, {
                            default: _withCtx(() => [
                              (isSpeedDialOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (_unref(actionMap).edit)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            "data-testid": "station-details-edit-station-overflow-button",
                                            disabled: _unref(actionMap).edit.disabled,
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(actionMap).edit.handler())),
                                            class: "w-9 h-9 rounded-full border-2 border-solid border-primary30 bg-white flex items-center justify-center shadow-md hover:bg-primary5 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white",
                                            title: "Editar Plantão"
                                          }, [
                                            _createVNode(EditPencilIcon, {
                                              color: "#2F7F91",
                                              class: "w-[18px] h-[18px]"
                                            })
                                          ], 8, _hoisted_12),
                                          (_unref(actionMap).edit.disabled)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                activator: "parent",
                                                location: "top",
                                                text: _unref(actionMap).edit.disabledReason
                                              }, null, 8, ["text"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(actionMap).remove)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            "data-testid": "station-details-remove-doctor-button",
                                            disabled: _unref(actionMap).remove.disabled,
                                            class: "w-9 h-9 rounded-full border-2 border-solid border-negative bg-white flex items-center justify-center shadow-md hover:bg-negative/10 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white",
                                            title: "Remover Médico",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(actionMap).remove.handler()))
                                          }, [
                                            _createVNode(AccountRemove, {
                                              color: "red",
                                              class: "w-[18px] h-[18px]"
                                            })
                                          ], 8, _hoisted_14),
                                          (_unref(actionMap).remove.disabled)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                activator: "parent",
                                                location: "top",
                                                text: _unref(actionMap).remove.disabledReason
                                              }, null, 8, ["text"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_unref(actionMap).history)
                                      ? (_openBlock(), _createBlock(HistoryButton, {
                                          key: 2,
                                          status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                                          "is-active": isOpenHistorySidebar.value,
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(actionMap).history.handler())),
                                          size: "small",
                                          loading: loading.value
                                        }, null, 8, ["status", "is-active", "loading"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (!loading.value && stationDetails.value && _ctx.mode === 'dashboard' && _unref(flags).enabledSmartAllocation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_unref(actionMap).allocate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    _createElementVNode("button", {
                      "data-testid": "station-details-allocate-doctor-button-mobile",
                      disabled: _unref(actionMap).allocate.disabled,
                      title: isUnidentifiedStation.value ? 'Identificar médico' : undefined,
                      "aria-label": isUnidentifiedStation.value ? 'Identificar médico' : undefined,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(actionMap).allocate.handler())),
                      class: "w-9 h-9 rounded-full bg-primary flex items-center justify-center shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      (stationDetails.value?.doctorStation.doctor)
                        ? (_openBlock(), _createBlock(AccountSwitchIcon, {
                            key: 0,
                            color: "white",
                            class: "w-[14px] h-[14px]"
                          }))
                        : (_openBlock(), _createBlock(AccountPlus, {
                            key: 1,
                            color: "white",
                            class: "w-[14px] h-[14px]"
                          }))
                    ], 8, _hoisted_17),
                    (_unref(actionMap).allocate.disabled)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          text: _unref(actionMap).allocate.disabledReason
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(actionMap)['send-record'])
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    "data-testid": "station-details-send-record-mobile",
                    disabled: _unref(actionMap)['send-record'].disabled,
                    title: _unref(sendRecordTooltip),
                    class: "w-9 h-9 rounded-full border-2 border-solid border-primary30 bg-white flex items-center justify-center shadow-md disabled:opacity-50 disabled:cursor-not-allowed",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(actionMap)['send-record'].handler()))
                  }, [
                    _createVNode(SVGIcon, {
                      path: _unref(mdiUpload),
                      class: "w-[14px] h-[14px] text-primary30"
                    }, null, 8, ["path"])
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true),
              (_unref(actionMap).exceptionality)
                ? (_openBlock(), _createBlock(PadlockButton, {
                    key: 2,
                    status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                    "is-active": isOpenExceptionalitySidebar.value,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(actionMap).exceptionality.handler())),
                    loading: loading.value,
                    size: "small"
                  }, null, 8, ["status", "is-active", "loading"]))
                : _createCommentVNode("", true),
              (_unref(actionMap)['check-attempts'])
                ? (_openBlock(), _createBlock(CheckAttemptsButton, {
                    key: 3,
                    "test-id": "station-details-check-attempts-toggle-mobile",
                    "is-active": showCheckAttempts.value,
                    size: "small",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(actionMap)['check-attempts'].handler()))
                  }, null, 8, ["is-active"]))
                : _createCommentVNode("", true),
              (_unref(actionMap).edit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createElementVNode("button", {
                      type: "button",
                      "data-testid": "station-details-edit-station-overflow-button-mobile",
                      disabled: _unref(actionMap).edit.disabled,
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(actionMap).edit.handler())),
                      class: "w-9 h-9 rounded-full border-2 border-solid border-primary30 bg-white flex items-center justify-center shadow-md disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Editar Plantão"
                    }, [
                      _createVNode(EditPencilIcon, {
                        color: "#2F7F91",
                        class: "w-[14px] h-[14px]"
                      })
                    ], 8, _hoisted_20),
                    (_unref(actionMap).edit.disabled)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          text: _unref(actionMap).edit.disabledReason
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(actionMap).remove)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      "data-testid": "station-details-remove-doctor-button-mobile",
                      disabled: _unref(actionMap).remove.disabled,
                      class: "w-9 h-9 rounded-full border-2 border-solid border-negative bg-white flex items-center justify-center shadow-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Remover Médico",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(actionMap).remove.handler()))
                    }, [
                      _createVNode(AccountRemove, {
                        color: "red",
                        class: "w-[14px] h-[14px]"
                      })
                    ], 8, _hoisted_22),
                    (_unref(actionMap).remove.disabled)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          text: _unref(actionMap).remove.disabledReason
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(actionMap).history)
                ? (_openBlock(), _createBlock(HistoryButton, {
                    key: 6,
                    status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                    "is-active": isOpenHistorySidebar.value,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(actionMap).history.handler())),
                    size: "small",
                    loading: loading.value
                  }, null, 8, ["status", "is-active", "loading"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!loading.value && stationDetails.value && _ctx.mode === 'dashboard' && !_unref(flags).enabledSmartAllocation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (_unref(actionMap).edit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                    _createElementVNode("button", {
                      "data-testid": "station-details-edit-station-button",
                      disabled: _unref(actionMap).edit.disabled,
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(actionMap).edit.handler())),
                      class: "w-12 h-12 rounded-full bg-primary flex items-center justify-center shadow-md hover:bg-primary40 focus:outline-none focus:ring-2 focus:ring-primary30 focus:ring-opacity-75 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary"
                    }, [
                      _createVNode(EditPencilIcon, {
                        color: "white",
                        class: "w-[18px] h-[18px]"
                      })
                    ], 8, _hoisted_25),
                    (_unref(actionMap).edit.disabled)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          text: _unref(actionMap).edit.disabledReason
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(actionMap)['send-record'])
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    "data-testid": "station-details-send-record-legacy",
                    disabled: _unref(actionMap)['send-record'].disabled,
                    title: _unref(sendRecordTooltip),
                    class: "w-12 h-12 rounded-full border-2 border-solid border-primary30 bg-white flex items-center justify-center shadow-md hover:bg-primary5 focus:outline-none focus:ring-2 focus:ring-primary30 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(actionMap)['send-record'].handler()))
                  }, [
                    _createVNode(SVGIcon, {
                      path: _unref(mdiUpload),
                      class: "w-[18px] h-[18px] text-primary30"
                    }, null, 8, ["path"])
                  ], 8, _hoisted_26))
                : _createCommentVNode("", true),
              (_unref(actionMap).exceptionality)
                ? (_openBlock(), _createBlock(PadlockButton, {
                    key: 2,
                    status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                    "is-active": isOpenExceptionalitySidebar.value,
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(actionMap).exceptionality.handler())),
                    loading: loading.value
                  }, null, 8, ["status", "is-active", "loading"]))
                : _createCommentVNode("", true),
              (_unref(actionMap)['check-attempts'])
                ? (_openBlock(), _createBlock(CheckAttemptsButton, {
                    key: 3,
                    "test-id": "station-details-check-attempts-toggle",
                    "is-active": showCheckAttempts.value,
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(actionMap)['check-attempts'].handler()))
                  }, null, 8, ["is-active"]))
                : _createCommentVNode("", true),
              (_unref(actionMap).history)
                ? (_openBlock(), _createBlock(HistoryButton, {
                    key: 4,
                    status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                    "is-active": isOpenHistorySidebar.value,
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(actionMap).history.handler())),
                    loading: loading.value
                  }, null, 8, ["status", "is-active", "loading"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!loading.value && stationDetails.value && _ctx.mode === 'dashboard' && !_unref(flags).enabledSmartAllocation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_unref(actionMap).edit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                    _createElementVNode("button", {
                      "data-testid": "station-details-edit-station-button-mobile",
                      disabled: _unref(actionMap).edit.disabled,
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(actionMap).edit.handler())),
                      class: "w-9 h-9 rounded-full bg-primary flex items-center justify-center shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      _createVNode(EditPencilIcon, {
                        color: "white",
                        class: "w-[14px] h-[14px]"
                      })
                    ], 8, _hoisted_29),
                    (_unref(actionMap).edit.disabled)
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          activator: "parent",
                          location: "top",
                          text: _unref(actionMap).edit.disabledReason
                        }, null, 8, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(actionMap)['send-record'])
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    "data-testid": "station-details-send-record-legacy-mobile",
                    disabled: _unref(actionMap)['send-record'].disabled,
                    title: _unref(sendRecordTooltip),
                    class: "w-9 h-9 rounded-full border-2 border-solid border-primary30 bg-white flex items-center justify-center shadow-md disabled:opacity-50 disabled:cursor-not-allowed",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(actionMap)['send-record'].handler()))
                  }, [
                    _createVNode(SVGIcon, {
                      path: _unref(mdiUpload),
                      class: "w-[14px] h-[14px] text-primary30"
                    }, null, 8, ["path"])
                  ], 8, _hoisted_30))
                : _createCommentVNode("", true),
              (_unref(actionMap).exceptionality)
                ? (_openBlock(), _createBlock(PadlockButton, {
                    key: 2,
                    status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                    "is-active": isOpenExceptionalitySidebar.value,
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_unref(actionMap).exceptionality.handler())),
                    loading: loading.value,
                    size: "small"
                  }, null, 8, ["status", "is-active", "loading"]))
                : _createCommentVNode("", true),
              (_unref(actionMap)['check-attempts'])
                ? (_openBlock(), _createBlock(CheckAttemptsButton, {
                    key: 3,
                    "test-id": "station-details-check-attempts-toggle-mobile",
                    "is-active": showCheckAttempts.value,
                    size: "small",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(actionMap)['check-attempts'].handler()))
                  }, null, 8, ["is-active"]))
                : _createCommentVNode("", true),
              (_unref(actionMap).history)
                ? (_openBlock(), _createBlock(HistoryButton, {
                    key: 4,
                    status: stationDetails.value?.doctorStation?.exceptionSummaryStatus || null,
                    "is-active": isOpenHistorySidebar.value,
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_unref(actionMap).history.handler())),
                    loading: loading.value,
                    size: "small"
                  }, null, 8, ["status", "is-active", "loading"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => []),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col w-full", isFullScreen.value ? '' : 'max-h-[70vh]'])
        }, [
          (loading.value)
            ? (_openBlock(), _createBlock(StationDetailsSkeleton, { key: 0 }))
            : (errorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(errorMessage.value), 1))
              : (stationDetails.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      (!isUnidentifiedStation.value && stationDetails.value?.doctorStation?.userSponsor?.name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("span", null, _toDisplayString(stationDetails.value.doctorStation.userSponsor.name), 1),
                            (stationDetails.value.doctorStation.userSponsor.registration)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, " #" + _toDisplayString(stationDetails.value.doctorStation.userSponsor.registration), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_39, [
                        (formattedStartDate.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                              _createTextVNode(" De "),
                              _createElementVNode("span", _hoisted_41, _toDisplayString(formattedStartDate.value.weekday) + ",", 1),
                              _createTextVNode(" " + _toDisplayString(formattedStartDate.value.date) + " ", 1),
                              _createElementVNode("span", _hoisted_42, "às " + _toDisplayString(formattedStartDate.value.time), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (formattedEndDate.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                              _createTextVNode(" Até "),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(formattedEndDate.value.weekday) + ",", 1),
                              _createTextVNode(" " + _toDisplayString(formattedEndDate.value.date) + " ", 1),
                              _createElementVNode("span", _hoisted_45, "às " + _toDisplayString(formattedEndDate.value.time), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (getTimezoneTitle(stationDetails.value.timezone))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Horário de " + _toDisplayString(getTimezoneTitle(stationDetails.value.timezone)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (isUnidentifiedStation.value)
                        ? (_openBlock(), _createBlock(OptionalCollapsible, {
                            key: 1,
                            enabled: isFullScreen.value,
                            title: "Médico",
                            "test-id": "mobile-doctor-accordion",
                            summary: mobileSummaries.value.doctor
                          }, {
                            default: _withCtx(() => [
                              _createVNode(UnidentifiedCoverageDetails, {
                                "responsible-name": coverageInfo.value.responsibleName,
                                note: coverageInfo.value.note,
                                "station-type-label": unidentifiedStationTypeLabel.value,
                                "position-name": stationDetails.value.position?.name,
                                "shift-name": stationDetails.value.shift?.name,
                                "reference-value": unidentifiedReferenceValue.value,
                                "show-actions": showCoverageActions.value,
                                "can-identify": canAllocateDoctor.value,
                                "can-edit-responsible": canEditUnidentifiedResponsible.value,
                                "can-release": canRemoveDoctor.value,
                                "actions-disabled": _unref(isPostStationLocked),
                                "reserve-actions-lane": _ctx.mode === 'dashboard' && !isFullScreen.value,
                                onIdentify: _cache[24] || (_cache[24] = ($event: any) => (openManagement(_unref(CoverageMode).DOCTOR))),
                                onEditResponsible: _cache[25] || (_cache[25] = ($event: any) => (openManagement(_unref(CoverageMode).UNIDENTIFIED))),
                                onRelease: openRelease
                              }, null, 8, ["responsible-name", "note", "station-type-label", "position-name", "shift-name", "reference-value", "show-actions", "can-identify", "can-edit-responsible", "can-release", "actions-disabled", "reserve-actions-lane"])
                            ]),
                            _: 1
                          }, 8, ["enabled", "summary"]))
                        : (!stationDetails.value.doctorStation?.doctor)
                          ? (_openBlock(), _createBlock(OptionalCollapsible, {
                              key: 2,
                              enabled: isFullScreen.value,
                              title: "Médico",
                              "test-id": "mobile-doctor-accordion",
                              summary: mobileSummaries.value.doctor
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["text-left text-base rounded py-1 px-2", stationTypeClass.value])
                                    }, _toDisplayString(formattedStationType.value), 3)
                                  ]),
                                  (formattedStationType.value !== 'ABERTA' && canReadPaymentRules.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        _hoisted_49,
                                        _createElementVNode("div", _hoisted_50, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card, index) => {
                                            return _createVNode(CardDutyFee, {
                                              key: index,
                                              formation: card.formation,
                                              value: formattedStationType.value === 'ABERTA' ? undefined : card.value,
                                              repassMode: card.repassMode,
                                              active: stationDetails.value.value === card.value
                                            }, null, 8, ["formation", "value", "repassMode", "active"])
                                          }), 64))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (canReadScheduleRequirements.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                        (formattedStationType.value !== 'ABERTA')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                              _hoisted_53,
                                              (formattedStationType.value !== 'ABERTA')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(stationDetails.value.ourTeam ? 'Interno' : 'Externo'), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_55, [
                                          _hoisted_56,
                                          _createElementVNode("span", null, _toDisplayString(stationDetails.value.position?.name || 'Não definida'), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                          _hoisted_58,
                                          _createElementVNode("span", null, _toDisplayString(stationDetails.value.shift?.name || 'Não definido'), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_59, [
                                          _hoisted_60,
                                          _createElementVNode("span", null, _toDisplayString(proportionalityRuleTitle.value), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["enabled", "summary"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex flex-col md:flex-row gap-4 md:gap-6", _ctx.mode === 'dashboard' && !isFullScreen.value ? 'md:pr-[calc(2.5vw_+_32px)]' : ''])
                              }, [
                                _createVNode(OptionalCollapsible, {
                                  enabled: isFullScreen.value,
                                  title: "Médico",
                                  "test-id": "mobile-doctor-accordion",
                                  summary: mobileSummaries.value.doctor
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(CardDutyWithDoctor, {
                                      formation: stationDetails.value?.doctorStation?.dsPaymentDoctorFormation?.name || '',
                                      team: stationDetails.value?.doctorStation?.ourTeam ? 'Interno' : 'Externo',
                                      position: stationDetails.value?.position?.name,
                                      shift: stationDetails.value?.shift?.name || '',
                                      dutyLabel: stationDetails.value?.doctorStation?.type,
                                      doctorName: stationDetails.value?.doctorStation?.doctor?.mainCrm?.name,
                                      doctorCrm: doctorCrmLabel.value,
                                      active: false,
                                      scheduleId: stationDetails.value.schedule.id,
                                      npsScore: stationDetails.value?.doctorNpsScore?.npsScore,
                                      avatarUrl: stationDetails.value?.doctorStation?.doctor?.user?.avatarUrl
                                    }, null, 8, ["formation", "team", "position", "shift", "dutyLabel", "doctorName", "doctorCrm", "scheduleId", "npsScore", "avatarUrl"])
                                  ]),
                                  _: 1
                                }, 8, ["enabled", "summary"]),
                                _createVNode(OptionalCollapsible, {
                                  enabled: isFullScreen.value && hasReadableValues.value,
                                  title: "Valores do plantão",
                                  "test-id": "mobile-values-accordion",
                                  summary: mobileSummaries.value.values,
                                  "default-expanded": false
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(ValueDetailsSection, {
                                      "original-value": valuePanelOriginalValue.value,
                                      "approved-value": 
                    _ctx.mode === 'approvals' &&
                    exceptionSummary.value?.financials?.totalExceptionalValue != null
                      ? Number(exceptionSummary.value.financials.totalExceptionalValue)
                      : null
                  ,
                                      "request-antecipe": stationDetails.value.doctorStation?.requestAntecipe,
                                      "antecipe-was-paid": stationDetails.value.doctorStation?.antecipeWasPaid,
                                      "is-exception-mode": _ctx.mode === 'approvals' && !!exceptionSummary.value,
                                      "approval-status": props.approvalStatusMap?.financials,
                                      scheduleId: stationDetails.value.schedule.id,
                                      "show-exception-lock": _ctx.mode === 'dashboard' && !!exceptionSummary.value
                                    }, null, 8, ["original-value", "approved-value", "request-antecipe", "antecipe-was-paid", "is-exception-mode", "approval-status", "scheduleId", "show-exception-lock"])
                                  ]),
                                  _: 1
                                }, 8, ["enabled", "summary"])
                              ], 2),
                              (exceptionSummary.value?.changes && _ctx.mode === 'approvals')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createVNode(RepassProportionalityDetailsSection, {
                                      "original-repass-mode": exceptionSummary.value?.changes.repassMode?.original,
                                      "current-repass-mode": exceptionSummary.value?.changes.repassMode?.requested,
                                      "original-proportionality-rule": 
                  exceptionSummary.value?.changes.proportionalityRule?.original
                ,
                                      "current-proportionality-rule": 
                  exceptionSummary.value?.changes.proportionalityRule?.requested
                ,
                                      "repass-mode-status": props.approvalStatusMap?.repassMode,
                                      "proportionality-rule-status": props.approvalStatusMap?.proportionalityRule
                                    }, null, 8, ["original-repass-mode", "current-repass-mode", "original-proportionality-rule", "current-proportionality-rule", "repass-mode-status", "proportionality-rule-status"])
                                  ]))
                                : (
                _ctx.mode === 'dashboard' && (canReadPaymentRules.value || canReadProportionalityRule.value)
              )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                      (canReadPaymentRules.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            _createElementVNode("span", _hoisted_65, [
                                              (exceptionSummary.value)
                                                ? (_openBlock(), _createBlock(SVGIcon, {
                                                    key: 0,
                                                    path: _unref(mdiLockOpenVariant),
                                                    class: "inline-block w-4 h-4 text-negative align-text-bottom mr-1"
                                                  }, null, 8, ["path"]))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(" Modalidade de repasse ")
                                            ]),
                                            (stationDetails.value.doctorStation?.inCash != null)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(stationDetails.value.doctorStation?.inCash ? 'À vista' : 'Fluxo'), 1))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _hoisted_67,
                                                  (stationDetails.value.value == null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                                                        _hoisted_69,
                                                        _createTextVNode(" Nenhuma política de pagamento aplicável ")
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (canReadProportionalityRule.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                            _createElementVNode("span", _hoisted_71, [
                                              (exceptionSummary.value)
                                                ? (_openBlock(), _createBlock(SVGIcon, {
                                                    key: 0,
                                                    path: _unref(mdiLockOpenVariant),
                                                    class: "inline-block w-4 h-4 text-negative align-text-bottom mr-1"
                                                  }, null, 8, ["path"]))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(" Regra de proporcionalidade ")
                                            ]),
                                            (stationDetails.value.schedule?.proportionalityRule)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(proportionalityRuleTitle.value), 1))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _hoisted_73,
                                                  (stationDetails.value.value == null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                                                        _hoisted_75,
                                                        _createTextVNode(" Nenhuma política de pagamento aplicável ")
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                              (exceptionSummary.value?.changes.workJourney && _ctx.mode === 'approvals')
                                ? (_openBlock(), _createBlock(WorkJourneyDetailsSection, {
                                    key: 2,
                                    "original-start-hour": exceptionSummary.value?.changes.workJourney.original.startHour,
                                    "original-end-hour": exceptionSummary.value?.changes.workJourney.original.endHour,
                                    "requested-start-hour": exceptionSummary.value?.changes.workJourney.requested.startHour,
                                    "requested-end-hour": exceptionSummary.value?.changes.workJourney.requested.endHour,
                                    timezone: stationDetails.value.timezone,
                                    "approval-status": props.approvalStatusMap?.workJourney
                                  }, null, 8, ["original-start-hour", "original-end-hour", "requested-start-hour", "requested-end-hour", "timezone", "approval-status"]))
                                : _createCommentVNode("", true),
                              (_ctx.mode === 'dashboard')
                                ? (_openBlock(), _createBlock(StationRequiredCheckLine, {
                                    key: 3,
                                    "required-check-source": stationDetails.value.requiredCheckSource,
                                    "required-check-policy": stationDetails.value.requiredCheckPolicy,
                                    "required-check": stationDetails.value.requiredCheck,
                                    "required-check-method": stationDetails.value.requiredCheckMethod,
                                    "our-team": stationDetails.value.ourTeam,
                                    "schedule-flags": scheduleCheckFlags.value,
                                    "touch-target": isFullScreen.value,
                                    onOpenPolicy: openSchedulePolicy
                                  }, null, 8, ["required-check-source", "required-check-policy", "required-check", "required-check-method", "our-team", "schedule-flags", "touch-target"]))
                                : _createCommentVNode("", true),
                              (_ctx.mode === 'dashboard')
                                ? (_openBlock(), _createBlock(StationRegistrationSection, {
                                    key: 4,
                                    "touch-target": isFullScreen.value,
                                    "exception-summary": exceptionSummary.value,
                                    "show-doctor-check": showDoctorCheck.value,
                                    "main-check": mainCheck.value,
                                    "permanence-visibility": permanenceVisibility.value,
                                    "attendance-status": attendanceStatus.value,
                                    "loading-ds-evidence": loadingDsEvidence.value,
                                    "has-station-started": hasStationStarted.value,
                                    "has-station-ended": hasStationEnded.value,
                                    "can-read-doctor-check": canReadDoctorCheck.value,
                                    "is-conciliation-origin": isConciliationOrigin.value,
                                    checkin: checkin.value,
                                    checkout: checkout.value,
                                    registration: stationRegistration.value,
                                    "can-send-record": !_unref(isSendRecordDisabled),
                                    "our-team": stationDetails.value?.doctorStation?.ourTeam ?? null,
                                    "load-error": registrationLoadError.value,
                                    "expected-checkin": stationDetails.value.startHour,
                                    "expected-checkout": stationDetails.value.endHour,
                                    timezone: stationDetails.value.timezone,
                                    onNavigateToStation: _cache[26] || (_cache[26] = (stationId) => emit('navigateToStation', stationId)),
                                    onOpenEvidence: openEvidence,
                                    onOpenDsAttendanceEvidence: openDsAttendanceEvidence,
                                    onOpenVerification: openVerification,
                                    onRetryRegistration: fetchStationRegistration,
                                    onSendRecord: _cache[27] || (_cache[27] = ($event: any) => (handleSpeedDialAction('send-record'))),
                                    onViewEvidence: openStationEvidence
                                  }, null, 8, ["touch-target", "exception-summary", "show-doctor-check", "main-check", "permanence-visibility", "attendance-status", "loading-ds-evidence", "has-station-started", "has-station-ended", "can-read-doctor-check", "is-conciliation-origin", "checkin", "checkout", "registration", "can-send-record", "our-team", "load-error", "expected-checkin", "expected-checkout", "timezone"]))
                                : _createCommentVNode("", true),
                              (_ctx.mode === 'dashboard' && canReadDoctorCheck.value && _unref(canReadAttendance))
                                ? (_openBlock(), _createBlock(StationRecordsSection, {
                                    key: 5,
                                    "touch-target": isFullScreen.value,
                                    "doctor-station-id": stationDetails.value.doctorStation?.id ?? null
                                  }, null, 8, ["touch-target", "doctor-station-id"]))
                                : _createCommentVNode("", true),
                              (_ctx.mode === 'dashboard' && canReadDoctorCheck.value)
                                ? (_openBlock(), _createBlock(StationActivityRecordsSection, {
                                    key: 6,
                                    "touch-target": isFullScreen.value,
                                    ref_key: "activityRecordsSectionRef",
                                    ref: activityRecordsSectionRef,
                                    "doctor-station-id": stationDetails.value.doctorStation?.id ?? null,
                                    "activity-records-enabled": scheduleAcceptsActivityRecords.value,
                                    "can-send-record": !_unref(isSendRecordDisabled),
                                    timezone: stationDetails.value.timezone,
                                    "winning-legs": activityWinningLegs.value,
                                    onSendRecord: _cache[28] || (_cache[28] = ($event: any) => (handleSpeedDialAction('send-record')))
                                  }, null, 8, ["touch-target", "doctor-station-id", "activity-records-enabled", "can-send-record", "timezone", "winning-legs"]))
                                : _createCommentVNode("", true),
                              (hasRegistrationAccordions.value && canReadDoctorCheck.value)
                                ? (_openBlock(), _createBlock(CollapsibleSection, {
                                    key: 7,
                                    title: "Local e biometria",
                                    "test-id": "location-biometry-accordion",
                                    "touch-target": isFullScreen.value,
                                    summary: isFullScreen.value ? mobileSummaries.value.locationBiometry : undefined,
                                    class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("div", _hoisted_77, [
                                          _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(VERIFICATION_COLUMN_HEADER)), 1),
                                          (verificationButtonState.value !== 'NONE' && mainCheck.value)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                color: verificationButtonState.value === 'BIOMETRY' ? '#6B4FA3' : '#2F6F9F',
                                                depressed: "",
                                                class: "station-action-btn !text-white",
                                                "data-testid": "verification-button",
                                                onClick: _cache[29] || (_cache[29] = ($event: any) => (openVerification(mainCheck.value.id)))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(VERIFICATION_BUTTON_LABELS)[verificationButtonState.value]), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["color"]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(_unref(VERIFICATION_BUTTON_LABELS).NONE), 1))
                                        ]),
                                        _createElementVNode("div", _hoisted_80, [
                                          _hoisted_81,
                                          (mainCheck.value?.checkEvidences?.length)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                color: "primary",
                                                depressed: "",
                                                class: "station-action-btn",
                                                onClick: _cache[30] || (_cache[30] = ($event: any) => (openEvidence(mainCheck.value.checkEvidences)))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(mainCheck.value.checkEvidences.length) + " Arquivo" + _toDisplayString(mainCheck.value.checkEvidences.length > 1 ? 's' : ''), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (isConciliationOrigin.value && attendanceStatus.value.containerId)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 1,
                                                  color: "primary",
                                                  depressed: "",
                                                  class: "station-action-btn",
                                                  loading: loadingDsEvidence.value,
                                                  onClick: openDsAttendanceEvidence
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Visualizar ")
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading"]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_82, "Sem anexo"))
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["touch-target", "summary"]))
                                : _createCommentVNode("", true),
                              (hasRegistrationAccordions.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 8,
                                    ref_key: "checkAttemptsSectionRef",
                                    ref: checkAttemptsSectionRef,
                                    class: "text-left",
                                    "data-testid": "station-details-check-attempts"
                                  }, [
                                    _createVNode(CollapsibleSection, {
                                      expanded: showCheckAttempts.value,
                                      "onUpdate:expanded": _cache[31] || (_cache[31] = ($event: any) => ((showCheckAttempts).value = $event)),
                                      title: "Tentativas de check",
                                      "test-id": "check-attempts-accordion",
                                      "touch-target": isFullScreen.value,
                                      class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_83, [
                                          _createVNode(CheckAttemptsPanel, {
                                            source: checkAttemptsSource.value,
                                            compact: ""
                                          }, null, 8, ["source"])
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["expanded", "touch-target"])
                                  ], 512))
                                : _createCommentVNode("", true),
                              (attendanceStatusError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(attendanceStatusError.value), 1))
                                : _createCommentVNode("", true),
                              (
                hasStationStarted.value &&
                !showDoctorCheck.value &&
                _unref(flags).enabledDsAttendancePolicy &&
                !attendanceStatusError.value &&
                !attendanceStatus.value.hasApprovedRecord
              )
                                ? (_openBlock(), _createBlock(AttendanceAlert, {
                                    key: 10,
                                    date: formattedStartDate.value?.date,
                                    icon: AlertIcon,
                                    status: attendanceStatus.value.status,
                                    "is-overdue": attendanceStatus.value.isOverdue
                                  }, null, 8, ["date", "status", "is-overdue"]))
                                : _createCommentVNode("", true),
                              (showPostStationAccordion.value)
                                ? (_openBlock(), _createBlock(CollapsibleSection, {
                                    key: 11,
                                    title: "Pós-plantão",
                                    "test-id": "post-station-accordion",
                                    "touch-target": isFullScreen.value,
                                    summary: isFullScreen.value ? mobileSummaries.value.postStation : undefined,
                                    "default-expanded": false,
                                    class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(PostStationDetailsSection, {
                                        "station-id": stationDetails.value.id,
                                        "schedule-id": stationDetails.value.schedule.id,
                                        evaluation: _unref(postStationEvaluation),
                                        "show-title": false,
                                        onSidebarToggle: _cache[32] || (_cache[32] = ($event: any) => (isPostStationSidebarOpen.value = $event))
                                      }, null, 8, ["station-id", "schedule-id", "evaluation"])
                                    ]),
                                    _: 1
                                  }, 8, ["touch-target", "summary"]))
                                : (_openBlock(), _createBlock(PostStationDetailsSection, {
                                    key: 12,
                                    "station-id": stationDetails.value.id,
                                    "schedule-id": stationDetails.value.schedule.id,
                                    evaluation: _unref(postStationEvaluation),
                                    onSidebarToggle: _cache[33] || (_cache[33] = ($event: any) => (isPostStationSidebarOpen.value = $event))
                                  }, null, 8, ["station-id", "schedule-id", "evaluation"])),
                              (useAccordions.value && exceptionSummary.value)
                                ? (_openBlock(), _createBlock(CollapsibleSection, {
                                    key: 13,
                                    title: "Excepcionalidade",
                                    "test-id": "exceptionality-accordion",
                                    "touch-target": isFullScreen.value,
                                    summary: isFullScreen.value ? mobileSummaries.value.exceptionality : undefined,
                                    "default-expanded": false,
                                    class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_85, [
                                        _createElementVNode("span", _hoisted_86, _toDisplayString(exceptionalitySummaryText.value), 1),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "font-semibold text-primary30 underline",
                                          "data-testid": "station-details-exceptionality-open",
                                          onClick: _cache[34] || (_cache[34] = ($event: any) => (toggleSidebar('exceptionality')))
                                        }, " Ver excepcionalidade ")
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["touch-target", "summary"]))
                                : _createCommentVNode("", true)
                            ])),
                      (showCheckAttempts.value && !hasRegistrationAccordions.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 4,
                            ref_key: "checkAttemptsSectionRef",
                            ref: checkAttemptsSectionRef,
                            class: "text-left",
                            "data-testid": "station-details-check-attempts"
                          }, [
                            _createVNode(CollapsibleSection, {
                              title: "Tentativas de check",
                              "test-id": "check-attempts-accordion",
                              "touch-target": isFullScreen.value,
                              class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_87, [
                                  _createVNode(CheckAttemptsPanel, {
                                    source: checkAttemptsSource.value,
                                    compact: ""
                                  }, null, 8, ["source"])
                                ])
                              ]),
                              _: 1
                            }, 8, ["touch-target"])
                          ], 512))
                        : _createCommentVNode("", true),
                      (useAccordions.value && _unref(flags).enabledObservationsSystem && canReadObservations.value)
                        ? (_openBlock(), _createBlock(CollapsibleSection, {
                            key: 5,
                            title: "Observações",
                            "test-id": "observations-accordion",
                            "touch-target": isFullScreen.value,
                            summary: isFullScreen.value ? mobileSummaries.value.observations : undefined,
                            "default-expanded": false,
                            class: "rounded-lg border border-lightGray30 px-3 py-3 md:px-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(ObservationList, {
                                observations: formattedObservations.value,
                                "show-title": false,
                                onDelete: handleDeleteObservation
                              }, null, 8, ["observations"])
                            ]),
                            _: 1
                          }, 8, ["touch-target", "summary"]))
                        : (_unref(flags).enabledObservationsSystem && canReadObservations.value)
                          ? (_openBlock(), _createBlock(ObservationList, {
                              key: 6,
                              observations: formattedObservations.value,
                              onDelete: handleDeleteObservation
                            }, null, 8, ["observations"]))
                          : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 2
    }, [
      (mobileBadges.value.length)
        ? {
            name: "header-extra",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileBadges.value, (badge) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: badge.id,
                    "data-testid": `station-details-mobile-badge-${badge.id}`,
                    class: _normalizeClass(["rounded px-2 py-0.5 text-xs font-medium text-textPrimary", badge.class])
                  }, _toDisplayString(badge.label), 11, _hoisted_32))
                }), 128))
              ])
            ]),
            key: "0"
          }
        : undefined,
      (isDetailReady.value && _unref(stationActions).length)
        ? {
            name: "dock",
            fn: _withCtx(() => [
              _createVNode(StationDetailsDock, { actions: _unref(stationActions) }, null, 8, ["actions"])
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["open", "full-screen", "meta", "class"]),
    _createVNode(MobileOverlayLayer, { active: isFullScreen.value }, {
      default: _withCtx(() => [
        _createVNode(ExceptionalitiesSidebar, {
          "is-open": isOpenExceptionalitySidebar.value,
          "onUpdate:isOpen": _cache[35] || (_cache[35] = ($event: any) => ((isOpenExceptionalitySidebar).value = $event)),
          "doctor-station-id": Number(stationDetails.value?.doctorStation.id),
          "schedule-id": Number(stationDetails.value?.schedule.id),
          "station-context": stationContextData.value,
          "auto-open-exception-id": props.exceptionIdSelected,
          "post-station-locked": _unref(isPostStationLocked),
          onRequestNew: handleNewRequest,
          onActionCompletedReloadData: fetchStationDetails
        }, null, 8, ["is-open", "doctor-station-id", "schedule-id", "station-context", "auto-open-exception-id", "post-station-locked"]),
        _createVNode(HistorySidebar, {
          "is-open": isOpenHistorySidebar.value,
          "onUpdate:isOpen": _cache[36] || (_cache[36] = ($event: any) => ((isOpenHistorySidebar).value = $event)),
          "doctor-station-id": Number(stationDetails.value?.doctorStation.id),
          onRequestNew: handleNewRequest
        }, null, 8, ["is-open", "doctor-station-id"]),
        (stationDetails.value)
          ? (_openBlock(), _createBlock(NewExceptionalityRequest, {
              key: 0,
              "is-open": isOpenRequestExceptionality.value,
              "onUpdate:isOpen": _cache[37] || (_cache[37] = ($event: any) => ((isOpenRequestExceptionality).value = $event)),
              "original-start": stationDetails.value?.startHour,
              "original-end": stationDetails.value?.endHour,
              timezone: stationDetails.value?.timezone,
              "proportionality-rule": stationDetails.value?.schedule?.proportionalityRule,
              "base-hourly-rate": baseHourlyRate.value || 0,
              "doctor-station-id": stationDetails.value?.doctorStation?.id,
              "original-in-cash": stationDetails.value?.doctorStation?.inCash,
              "schedule-id": Number(stationDetails.value?.schedule.id),
              "station-context": stationContextData.value,
              "post-station-locked": _unref(isPostStationLocked),
              onRequestCreated: fetchStationDetails
            }, null, 8, ["is-open", "original-start", "original-end", "timezone", "proportionality-rule", "base-hourly-rate", "doctor-station-id", "original-in-cash", "schedule-id", "station-context", "post-station-locked"]))
          : _createCommentVNode("", true),
        _createVNode(ManagementDoctorModal, {
          showModal: isManagementDoctorModalOpen.value,
          stationDetails: stationDetails.value,
          mode: stationDetails.value?.doctorStation.doctor ? 'change' : 'allocate',
          "initial-coverage": managementInitialCoverage.value,
          onCloseModal: _cache[38] || (_cache[38] = ($event: any) => (isManagementDoctorModalOpen.value = false)),
          onAllocationUpdated: fetchStationDetails
        }, null, 8, ["showModal", "stationDetails", "mode", "initial-coverage"]),
        _createVNode(RemoveDoctorModal, {
          showModal: isRemovedDoctorModalOpen.value,
          stationDetails: stationDetails.value,
          release: isReleaseMode.value,
          onCloseModal: closeRemoveDoctorModal,
          onRemovalUpdated: fetchStationDetails
        }, null, 8, ["showModal", "stationDetails", "release"]),
        _createVNode(EvidenceModal, {
          "is-open": isEvidenceModalOpen.value,
          "onUpdate:isOpen": _cache[39] || (_cache[39] = ($event: any) => ((isEvidenceModalOpen).value = $event)),
          id: String(selectedEvidence.value?.id ?? ''),
          "file-name": selectedEvidence.value?.name ?? '',
          file: null,
          "file-url": evidenceBlobUrl.value ?? selectedEvidence.value?.path,
          files: selectedEvidenceFiles.value,
          uploader: evidenceUploader.value,
          "monitoring-type": mainCheck.value?.originLabel ?? '',
          "source-app": attendanceStatus.value.sourceApp ?? '',
          status: _unref(DSAttendanceStatus).APPROVED,
          "history-events": historyEvents.value
        }, null, 8, ["is-open", "id", "file-name", "file-url", "files", "uploader", "monitoring-type", "source-app", "status", "history-events"]),
        _createVNode(CheckVerificationModal, {
          "is-open": isVerificationModalOpen.value,
          "onUpdate:isOpen": _cache[40] || (_cache[40] = ($event: any) => ((isVerificationModalOpen).value = $event)),
          "check-id": verificationCheckId.value
        }, null, 8, ["is-open", "check-id"]),
        (isStationEvidenceModalOpen.value && stationEvidenceContext.value)
          ? (_openBlock(), _createBlock(StationEvidenceModal, {
              key: 1,
              modelValue: isStationEvidenceModalOpen.value,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((isStationEvidenceModalOpen).value = $event)),
              context: stationEvidenceContext.value
            }, null, 8, ["modelValue", "context"]))
          : _createCommentVNode("", true),
        (isSendRecordModalOpen.value && sendRecordContext.value)
          ? (_openBlock(), _createBlock(_unref(SendRecordModal), {
              key: 2,
              modelValue: isSendRecordModalOpen.value,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((isSendRecordModalOpen).value = $event)),
              context: sendRecordContext.value,
              "doctor-station-id": sendRecordContext.value.doctorStationId,
              "schedule-id": sendRecordContext.value.scheduleId,
              onSaved: handleSendRecordSaved,
              onRedirectToSheet: handleRedirectToSheet
            }, null, 8, ["modelValue", "context", "doctor-station-id", "schedule-id"]))
          : _createCommentVNode("", true),
        (isAttendanceUploadModalOpen.value)
          ? (_openBlock(), _createBlock(_unref(AttendanceUploadModal), {
              key: 3,
              modelValue: isAttendanceUploadModalOpen.value,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((isAttendanceUploadModalOpen).value = $event)),
              "initial-form": sheetInitialForm.value,
              "locked-fields": sheetLockedFields.value,
              onSave: handleSendRecordSaved
            }, null, 8, ["modelValue", "initial-form", "locked-fields"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
}
}

})